/** English translations */
export default {
  'paidScript.title': 'Prepaid script session',
  'paidScript.allowScript': 'Allow this script in prepaid sessions',
  'paidScript.scriptHint': 'One total payment, then gradual media delivery without additional PPV. Ordinary per-stage sales remain available.',
  'paidScript.price': 'Whole-script price, USD',
  'paidScript.terms': 'The price and composition are frozen when a quote is registered. New settings do not change existing contracts. This is not unlimited chat or a duration promise.',
  'paidScript.modelEnabled': 'Enable this mode for the model',
  'paidScript.modelHint': 'Off by default. After enabling, allow selected scripts and set their total prices. This switch does not send messages or turn manual mode off.',
  'paidScript.configScope': 'Default configuration: {name}. Per-chat configurations are unchanged.',
  'paidScript.sharedConfig': 'Assign a model-specific default configuration; shared multi-model configurations cannot be changed here.',
  'paidScript.disableConfirm': 'Disable this mode? Existing contracts and access will remain, but delivery will be held without falling back to additional PPV.',
  'paidScript.loadError': 'Could not load paid-session settings',
  'paidScript.saveError': 'Could not save paid-session settings',
  'paidScript.loading': 'Loading settings…',
  'paidScript.noScripts': 'No eligible scripts. In Content, allow a script in prepaid sessions and set its total price.',
  'app.name': 'FanLTV',
  'safetyReview.noticeTitle': 'Automatic replies are safety-locked',
  'safetyReview.noticeExplanation': 'This lock is removed only after confirming a safety review. VIP mode alone does not unlock the conversation.',
  'safetyReview.active': 'Safety lock remains active. {target}',
  'safetyReview.reason': 'Reason: {reason}',
  'safetyReview.since': 'Locked at: {time}',
  'safetyReview.reasonUnknown': 'Reason unavailable — inspect the conversation first',
  'safetyReview.unknown': 'Unknown',
  'safetyReview.stateConflict': 'The conversation state changed, but the safety lock was not cleared.',
  'safetyReview.checkFirst': 'Only continue after reviewing the conversation and confirming it is safe to resume.',
  'safetyReview.confirmResume': 'Enabling auto will remove this safety lock and allow automatic replies. I have reviewed the conversation — continue?',
  'safetyReview.confirmUnlock': 'Confirm: I have reviewed this lock. Unlock it? Manual mode will not be disabled.',

  // Layout / navigation
  'layout.theme.light': 'Light theme',
  'layout.theme.dark': 'Dark theme',
  'layout.logout': 'Log out',
  'layout.nav.models': 'Models',
  'layout.nav.fyp': 'FYP Publisher',
  'layout.nav.fans': 'Fans',
  'layout.nav.chats': 'Chats',
  'layout.nav.analytics': 'Analytics',
  'layout.nav.purchases': 'Purchases',
  'layout.nav.logs': 'Logs',
  'layout.nav.settings': 'Bot settings',
  'layout.nav.configuration': 'Configurations',
  'layout.language': 'Language',
  'layout.language.ru': 'Russian',
  'layout.language.en': 'English',
  'layout.language.ruShort': 'RU',
  'layout.language.enShort': 'EN',

  // Autotests
  'autotests.nav.title': 'Autotests',
  'autotests.nav.dashboard': 'Tests',
  'autotests.nav.scenarios': 'Scenarios',
  'autotests.nav.analysis': 'Log Analysis',
  'autotests.runAll': 'Run all autotests',
  'autotests.run': 'Run',
  'autotests.status.PASSED': 'Passed',
  'autotests.status.FAILED': 'Failed',
  'autotests.status.RUNNING': 'Running',
  'autotests.status.ERROR': 'Error',
  'autotests.scenarios.create': 'Create scenario',
  'autotests.rounds.title': 'Rounds',
  'autotests.conversation': 'Conversation',
  'autotests.analysis.quickScan': 'Quick Scan',
  'autotests.analysis.daily': 'Daily Report',
  'autotests.analysis.weekly': 'Weekly Report',
  'autotests.analysis.buildReport': 'Build report',
  'autotests.noAccess.title': 'No access',
  'autotests.noAccess.message': 'You do not have permissions for autotests.',
  'autotests.noAccess.back': 'Back',
  'autotests.dashboard.subtitle': 'Run overview, alerts, and latest execution status',
  'autotests.dashboard.summary': 'Summary',
  'autotests.dashboard.latestReport': 'Latest analysis report',
  'autotests.dashboard.latestRuns': 'Latest runs',
  'autotests.filters.status': 'Status',
  'autotests.filters.all': 'All',
  'autotests.filters.active': 'Active',
  'autotests.filters.inactive': 'Inactive',
  'autotests.validation.modelFanRequired': 'model_id and fan_id are required positive integers',
  'autotests.validation.maxRounds': 'max_rounds must be an integer >= 1',
  'autotests.validation.timeout': 'round_timeout_seconds must be an integer >= 10',
  'autotests.validation.scenarioId': 'scenario_id must match [a-z0-9_\\-]{3,100}',
  'autotests.validation.nameRequired': 'name is required',
  'autotests.validation.configJson': 'config must be valid JSON',
  'autotests.validation.modelRequired': 'Provide valid model_id',
  'autotests.validation.fanRequired': 'Provide valid fan_id',
  'autotests.validation.hours': 'hours must be an integer in range 1..168',
  'autotests.toast.started': 'Tests started',
  'autotests.toast.taskStarted': 'Task started: {task_id}',
  'autotests.scenarioCreated': 'Scenario created',
  'autotests.scenarios.subtitle': 'Scenarios list and manual execution',
  'autotests.scenarios.steps': 'Steps count',
  'autotests.scenarios.viewConfig': 'View config',
  'autotests.scenarios.configHintTitle': 'Config JSON hint',
  'autotests.scenarios.configHintRuleId': 'Use a stable scenario_id (latin letters, digits, _, -).',
  'autotests.scenarios.configHintRuleSteps': 'Place scenario rounds into the steps array.',
  'autotests.scenarios.configHintRuleExpected': 'Use expected to describe resulting bot state and goal.',
  'autotests.scenarios.useMinimalTemplate': 'Insert minimal template',
  'autotests.scenarios.generateSimpleConfig': 'Generate simple config',
  'autotests.status': 'Status',
  'autotests.date': 'Date',
  'autotests.scenario': 'Scenario',
  'autotests.passedFailed': 'passed / failed',
  'autotests.runDetail.subtitle': 'Run details',
  'autotests.backToDashboard': 'Back to dashboard',
  'autotests.rounds.total': 'Total rounds',
  'autotests.rounds.noBotResponse': 'Response is missing',
  'autotests.analysis.subtitle': 'Run analysis tasks and inspect reports',
  'autotests.analysis.tasks': 'Quick tasks',
  'autotests.analysis.modelTask': 'Run by model',
  'autotests.analysis.reports': 'Reports',
  'autotests.expand': 'Show more',
  'autotests.collapse': 'Show less',
  'autotests.empty': 'No data yet',
  'autotests.form.modelId': 'Model',
  'autotests.form.fanId': 'Fan',
  'autotests.form.maxRounds': 'Max rounds',
  'autotests.form.roundTimeoutSeconds': 'Round timeout (sec)',
  'autotests.form.activeOnly': 'Active scenarios only',
  'autotests.form.scenarioId': 'Scenario ID',
  'autotests.form.scenarioIdOptionalPlaceholder': 'optional, auto-generated if empty',
  'autotests.form.name': 'Name',
  'autotests.form.description': 'Description',
  'autotests.form.configJson': 'Config (JSON)',
  'autotests.form.round': 'Round',
  'autotests.form.fanBehavior': 'Fan behavior',
  'autotests.form.botStateAfter': 'State after step',
  'autotests.form.botGoal': 'Bot goal',
  'autotests.form.reportType': 'Report type',
  'autotests.form.hours': 'Hours (1..168)',
  'autotests.form.scopeType': 'Scope',
  'autotests.form.isTest': 'Test data only',
  'autotests.form.period': 'Period',
  'autotests.form.summary': 'Summary',
  'autotests.form.anomalies': 'Anomalies',
  'autotests.form.recommendations': 'Recommendations',
  'autotests.form.fanMessage': 'Fan message',
  'autotests.form.botResponse': 'Bot response',
  'autotests.form.stateTransition': 'State: before → after',
  'autotests.form.goalSelected': 'Selected goal',
  'autotests.form.qualityScores': 'Quality scores',
  'autotests.form.assertions': 'Assertions',
  'autotests.form.durationMs': 'Duration (ms)',
  'autotests.help.round': 'Step number in scenario flow (1, 2, 3...).',
  'autotests.help.fanBehavior': 'What fan does/says on this step (e.g. casual_greeting).',
  'autotests.help.botStateAfter': 'Expected bot state after handling this step.',
  'autotests.help.botGoal': 'Expected bot goal after this step (e.g. warm_up, offer).',

  // Login
  'login.title': 'FanLTV',
  'login.titleAdmin': 'Admin',
  'login.titleUser': 'Log in',
  'login.titleTester': 'Tester',
  'login.username': 'Username',
  'login.password': 'Password',
  'login.error': 'Login error',
  'login.submit': 'Log in',
  'login.submitting': 'Logging in…',

  // Common
  'common.loading': 'Loading…',
  'common.add': 'Add',
  'common.cancel': 'Cancel',
  'common.save': 'Save',
  'common.saving': 'Saving…',
  'common.delete': 'Delete',
  'common.deleting': 'Deleting…',
  'common.error': 'Error',
  'common.retry': 'Retry',
  'common.notSelected': 'Not selected',
  'common.notAvailable': '—',
  'common.edit': 'Edit',
  'common.actions': 'Actions',
  'common.loadMore': 'Load more',
  'pagination.range': '{from}–{to} of {total}',
  'pagination.page': 'Page {n}',
  'common.close': 'Close',

  // Toast notifications
  'toast.media.movedToSession': 'Media moved to photoset',
  'toast.media.movedToSessionCount': '{count} media moved to photoset',
  'toast.media.unlinkedFromSession': 'Media unlinked from photoset',
  'toast.media.unlinkedFromSessionCount': '{count} media unlinked from photoset',
  'toast.media.moved': 'Media moved',
  'toast.media.movedCount': '{count} media moved',
  'toast.media.movedToUngrouped': 'Media moved to «No group»',
  'toast.media.movedToUngroupedCount': '{count} media moved to «No group»',
  'toast.media.saved': 'Media saved',
  'toast.session.createdWithMedia': 'Photoset created, media moved',
  'toast.session.createdWithMediaCount': 'Photoset created, {count} media moved',
  'toast.session.saved': 'Photoset saved',
  'toast.session.deleted': 'Photoset deleted',
  'toast.group.created': 'Group created',
  'toast.group.deleted': 'Group deleted',
  'toast.groups.reordered': 'Group order changed',
  'toast.sessions.reordered': 'Photo session order changed',
  'toast.order.changed': 'Order changed',
  'toast.sync.started': 'Sync started',
  'toast.sync.stopped': 'Sync stopped',
  'toast.model.created': 'Model created',
  'toast.model.deleted': 'Model deleted',
  'toast.connection.started': 'Connection started',
  'toast.connection.cancelled': 'Connection cancelled',
  'toast.provider.disconnected': 'Provider disconnected',
  'toast.credentials.saved': 'Credentials saved',
  'toast.account.descriptionSaved': 'Account description saved',
  'toast.user.created': 'User created',
  'toast.user.updated': 'User updated',
  'toast.user.deleted': 'User deleted',
  'toast.user.modelAdded': 'Model assigned',
  'toast.user.modelRemoved': 'Model unassigned',
  'toast.error.moveFailed': 'Failed to move',
  'toast.error.createSessionFailed': 'Failed to create photoset',
  'toast.error.reorderFailed': 'Failed to change order',
  'toast.error.syncFailed': 'Sync error',
  'toast.error.stopSyncFailed': 'Failed to stop',
  'toast.settings.saved': 'Saved',
  'toast.settings.saveFailed': 'Failed to save',
  'toast.llm.grokFailed': 'Grok models unavailable: {error}',
  'toast.llm.openaiFailed': 'OpenAI models unavailable: {error}',
  'toast.llm.groqFailed': 'Groq models unavailable: {error}',
  'toast.llm.openrouterFailed': 'OpenRouter models unavailable: {error}',
  'toast.llm.minimaxFailed': 'MiniMax models unavailable: {error}',

  // Settings
  'settings.title': 'Configurations',
  'settings.nav.graph': 'Diagram',
  'settings.nav.overview': 'Overview',
  'settings.nav.configuration': 'Configuration',
  'settings.nav.agents': 'Agents',
  'settings.nav.nodes': 'Nodes',
  'settings.nav.edges': 'Edges',
  'settings.nav.variables': 'Variables',
  'settings.nav.proactive': 'Proactive bot',
  'settings.nav.executor': 'Executor / delivery',
  'settings.nav.other': 'Other settings',
  'settings.nav.users': 'Users',
  'settings.config.rename': 'Rename',
  'settings.config.renameModalTitle': 'Rename configuration',
  'settings.config.renamed': 'Configuration renamed',

  // Proactive bot (check_followup_needed, every 10 min)
  'settings.proactive.intro': 'The proactive bot runs every 10 minutes and decides whom to message first (silence follow-up). For selected fans it calls the proactive_message_generator agent to generate a message from parameters and conversation.',
  'settings.proactive.agentConfigLink': '→ Configure proactive_message_generator agent (model, prompts)',
  'settings.proactive.logicTitle': 'How the bot decides whom to message',
  'settings.proactive.logicIntro': 'check_followup_needed runs every 10 min. A fan gets a follow-up only if all conditions pass:',
  'settings.proactive.logicState': 'State (RAPPORT, FLIRT, PRESELL, OFFER, POSTBUY, COOLDOWN) → silence threshold in minutes. Hotter state = shorter threshold.',
  'settings.proactive.logicAttachment': 'emotional_attachment_score > 70 → threshold multiplied by multiplier (0.5 = twice as often).',
  'settings.proactive.logicRapportReturned': 'RAPPORT + fan wrote before (messages_processed_count > 0) → rapport_returned threshold, else rapport.',
  'settings.proactive.logicFilters': 'Other filters: not manual_mode, not SAFETY_LOCK, model ready, send_restriction (if enabled — only fans in allow-list). No active graph, debounce, delayed_send. last_message_at exists (fan wrote at least once).',
  'settings.proactive.logicCooldown': 'After followup_sent_at — no follow-up until the silence threshold passes (spam protection).',
  'settings.proactive.rulesTitle': 'Follow-up rules',
  'settings.proactive.rulesIntro': 'Add rules: conditions (L4 variables) + silence interval in minutes. Values are saved in 10-minute steps. First match wins.',
  'settings.proactive.ruleLabel': 'Rule {n}',
  'settings.proactive.hoursLabel': 'Hours',
  'settings.proactive.hoursUnit': 'h',
  'settings.proactive.minutesUnit': 'min',
  'settings.proactive.hoursCondition': 'Silence ≥',
  'settings.proactive.conditionsLabel': 'And conditions:',
  'settings.proactive.addRule': '+ Add rule',
  'settings.proactive.noRules': 'No rules. Add a rule.',
  'settings.proactive.ruleNameLabel': 'Rule name',
  'settings.proactive.ruleNamePlaceholder': 'Online comeback, high attachment, after purchase...',
  'settings.proactive.rulePromptLabel': 'Prompt for this condition',
  'settings.proactive.rulePromptPlaceholder': 'Extra instruction used only when this rule matches. Example: mention that she just saw him online, keep it light, ask one easy question.',
  'settings.proactive.desc.bot_silence_followup_rapport_hours': 'Follow-up — bot messages the fan if they haven\'t replied for N hours. Threshold for RAPPORT (new fan, little conversation yet).',
  'settings.proactive.desc.bot_silence_followup_rapport_returned_hours': 'Follow-up — bot messages the fan after silence. Threshold for RAPPORT when fan returned after a pause (had a dialog before).',
  'settings.proactive.desc.bot_silence_followup_flirt_hours': 'Follow-up — bot messages the fan after silence. Threshold for FLIRT state (flirt, warm-up).',
  'settings.proactive.desc.bot_silence_followup_presell_hours': 'Follow-up — bot messages the fan after silence. Threshold for PRESELL state (selling, but no offer yet).',
  'settings.proactive.desc.bot_silence_followup_offer_hours': 'Follow-up — bot messages the fan after silence. Threshold for OFFER state (active selling).',
  'settings.proactive.desc.bot_silence_followup_postbuy_hours': 'Follow-up — bot messages the fan after silence. Threshold for POSTBUY state (just bought, aftercare).',
  'settings.proactive.desc.bot_silence_followup_cooldown_hours': 'Follow-up — bot messages the fan after silence. Threshold for COOLDOWN state (pause after purchase/offer).',
  // Users (admin)
  'users.hint': 'Create users, change passwords and roles. For user and agency roles, assign models.',
  'users.add': 'Add user',
  'users.username': 'Username',
  'users.role': 'Role',
  'users.role.admin': 'Admin',
  'users.role.agency': 'Agency',
  'users.role.user': 'User',
  'users.role.tester': 'Tester',
  'users.role.tester_no_media': 'Tester (no media)',
  'users.role.tester_plus': 'Tester plus',
  'users.agency.optionsTitle': 'Agency access',
  'users.agency.conditionalPromptsAccess': 'Allow conditional prompts editing',
  'users.agency.conditionalPromptsHint': 'Creates an agency-owned config copy and shows Conditional prompts in agency settings.',
  'users.agency.chatDiagnosticsAccess': 'Allow chat funnel and logs',
  'users.agency.chatDiagnosticsHint': 'Shows conversation stages, funnel signals and redacted bot execution logs only for models assigned to this agency.',
  'users.agency.engineApiAccess': 'Enable FanLTV Engine API',
  'users.agency.engineApiHint': 'Allows the agency to create scoped API clients for external creator, companion or dating platforms. Automatic sending remains separately controlled.',
  'users.agency.billingPlan': 'Billing plan',
  'users.agency.billingCurrency': 'Currency',
  'users.agency.billingRate': 'Rate per bot message',
  'users.agency.balance': 'Balance',
  'users.agency.topUp': 'Top up balance',
  'users.agency.topUpHint': 'Top-up amount is added to the saved balance when you press Save.',
  'users.agency.lowBalanceThreshold': 'Low balance threshold',
  'users.modelAccessTitle': 'Model access',
  'users.modelAccessHint': 'Selected models are assigned immediately after creation. Agency models use the agency config copy.',
  'users.isActive': 'Active',
  'users.active': 'Yes',
  'users.inactive': 'No',
  'users.password': 'Password',
  'users.passwordLeaveEmpty': 'leave empty to keep unchanged',
  'users.passwordPlaceholder': 'New password (if changing)',
  'users.passwordMin': 'Password must be at least 6 characters',
  'users.createTitle': 'New user',
  'users.editTitle': 'Edit user',
  'users.models': 'Models',
  'users.modelsTitle': 'Models for {username}',
  'users.modelsLinked': 'Assigned models',
  'users.modelsAdd': 'Add model',
  'users.addModel': 'Add',
  'users.noModels': 'No assigned models',
  'users.deleteConfirmTitle': 'Delete user?',
  'users.deleteConfirmMessage': 'User {username} will be deleted.',
  'users.createError': 'Failed to create user',
  'users.updateError': 'Failed to update user',
  'users.deleteError': 'Failed to delete user',
  'settings.tabs.graph': 'Graph',
  'settings.tabs.settings': 'Parameters',
  'settings.tabs.agents': 'Agents',
  'settings.tabs.prompts': 'Prompts',
  'settings.section.graph': 'Pipeline visualization',
  'settings.section.settings': 'Graph parameters (pipeline, silence, transitions)',
  'settings.section.agents': 'Agent configuration',
  'settings.section.prompts': 'Prompts with {{var}} variables',
  'settings.config.title': 'Configuration',
  'settings.config.importFromCurrent': 'Import from current settings',
  'settings.config.create': 'Create',
  'settings.config.createModalTitle': 'New configuration',
  'settings.config.empty': 'No configs. Create a configuration.',
  'settings.config.active': 'Active',
  'settings.config.activate': 'Activate',
  'settings.config.clone': 'Clone',
  'settings.config.delete': 'Delete',
  'settings.config.deleteConfirm': 'Delete config?',
  'settings.config.activateConfirmTitle': 'Activate configuration?',
  'settings.config.activateConfirmMessage': 'When switching configurations, all users (not testers) will use this configuration. Testers have their own configuration stored separately.',
  'settings.config.imported': 'Config created from current settings',
  'settings.config.created': 'Config created',
  'settings.config.cloned': 'Config cloned',
  'settings.config.rename': 'Rename',
  'settings.config.renameModalTitle': 'Rename configuration',
  'settings.config.renamed': 'Config renamed',
  'settings.config.activated': 'Config activated',
  'settings.config.deleted': 'Config deleted',
  'settings.config.errorLoad': 'Load error',
  'settings.config.namePrompt': 'Config name:',
  'settings.config.notFound': 'Configuration not found',
  'settings.config.backToList': 'Back to list',
  'settings.config.edit': 'Edit',
  'settings.deleteConditionTitle': 'Delete condition?',
  'settings.deleteConditionMessage': 'This condition will be removed.',
  'settings.deleteRuleTitle': 'Delete rule?',
  'settings.deleteRuleMessage': 'This rule will be removed.',
  'settings.deleteConditionalPromptTitle': 'Delete conditional prompt?',
  'settings.deleteConditionalPromptMessage': 'This conditional prompt will be removed.',
  'settings.loading': 'Loading…',
  'settings.promptsHint': 'Variables: {{payload_json}}, {{model_persona}}, {{explicit_level}}, etc.',
  'settings.agent.model': 'Model (LLM provider)',
  'settings.agent.asyncMode': 'async',
  'settings.agent.asyncModelsHint': 'Models marked (async) use webhook — no polling. Others: sync or polling.',
  'settings.agent.temperature': 'Temperature',
  'settings.agent.top_p': 'Top P',
  'settings.agent.top_p_hint': 'Nucleus sampling (0–1). Use with temperature, not both.',
  'settings.agent.max_tokens': 'Max tokens',
  'settings.agent.max_tokens_hint': 'Maximum response length.',
  'settings.agent.frequency_penalty': 'Frequency penalty',
  'settings.agent.frequency_penalty_hint': '-2 to 2. Penalizes repeated tokens.',
  'settings.agent.presence_penalty': 'Presence penalty',
  'settings.agent.presence_penalty_hint': '-2 to 2. Penalizes already present topics.',
  'settings.agent.conversationMessagesCount': 'Conversation messages in context',
  'settings.agent.label.message_analyzer': 'Message Analyzer',
  'settings.agent.label.photo_analyzer': 'Photo Analyzer',
  'settings.agent.label.script_generator': 'Message Generator', // legacy, displayed as message_generator
  'settings.agent.label.message_generator': 'Message Generator',
  'settings.agent.label.photo_generator': 'Photo Response Generator',
  'settings.agent.label.monetization': 'Offer Generator',
  'settings.agent.label.policy_safety': 'Content Moderator',
  'settings.agent.label.memory_summary': 'Memory Summarizer',
  'settings.agent.label.offer_generator': 'Offer Generator',
  'settings.agent.label.proactive_message_generator': 'Proactive Message Generator',
  'settings.prompt.placeholder': 'Prompt text…',
  'settings.prompt.roleSystem': 'System prompt',
  'settings.prompt.roleUser': 'User prompt',
  'settings.prompt.baseLabel': 'Base prompt',
  'settings.prompt.extraLabel': 'Additional prompts (always appended to base)',
  'settings.prompt.extraPlaceholder': 'Additional prompt text…',
  'settings.prompt.addExtra': '+ Add additional prompt',
  'settings.prompt.userReadonlyHint': 'The user prompt receives JSON data (structure below). Editing is disabled — the template is fixed.',
  'settings.prompt.payload.object': 'object',
  'settings.prompt.payload.ma.incoming_messages': 'incoming messages in current batch [{role, text}]',
  'settings.prompt.payload.ma.conversation_history': 'last N conversation messages [{role, text}]',
  'settings.prompt.payload.ma.conversation_messages_count': 'how many messages in conversation_history (setting)',
  'settings.prompt.payload.ma.responseFormatTitle': 'Response structure (text.format)',
  'settings.prompt.payload.ma.responseFormatDesc': 'This structure is passed to the API special field (text.format) and guarantees the LLM returns JSON strictly in this format.',
  'settings.prompt.payload.generator.outputFormatTitle': 'Response format',
  'settings.prompt.payload.generator.outputFormatDesc': 'Structure the LLM must return. Pass it in the user prompt and ask the model to return strictly this format (JSON or plain text).',
  'settings.prompt.payload.ma.output.intent': 'message type',
  'settings.prompt.payload.ma.output.tone': 'emotional tone',
  'settings.prompt.payload.ma.output.trust_score': 'trust level',
  'settings.prompt.payload.ma.output.attachment_score': 'emotional attachment',
  'settings.prompt.payload.ma.output.sexual_tension_score': 'sexual tension',
  'settings.prompt.payload.ma.output.spending_score': 'spending intent',
  'settings.prompt.payload.ma.output.resistance_score': 'resistance',
  'settings.prompt.payload.ma.output.user_arousal_score': 'user arousal',
  'settings.prompt.payload.ma.output.user_is_alone_score': 'user likely alone',
  'settings.prompt.payload.ma.output.user_privacy_score': 'privacy available',
  'settings.prompt.payload.ma.output.user_has_time_score': 'has time to continue',
  'settings.prompt.payload.ma.output.buy_signal': 'direct buy signal',
  'settings.prompt.payload.ma.output.realness_test_score': '"is model real" test',
  'settings.prompt.payload.ma.output.policy_risk_score': 'risky request',
  'settings.prompt.payload.ma.output.risk_flag': 'block graph (SAFETY_LOCK)',
  'settings.prompt.payload.ma.output.risk_reason': 'reason when risk_flag',
  'settings.prompt.payload.sg.tone_style': 'tone style: girlfriend, seductive, flirty, etc.',
  'settings.prompt.payload.sg.explicit_level': 'explicitness level 0–100',
  'settings.prompt.payload.sg.message_length': 'response length: short, medium, long',
  'settings.prompt.payload.sg.user_profile': 'fan numerical profile (engagement, attachment, etc.)',
  'settings.prompt.payload.sg.incoming_messages': 'incoming messages (array of elements)',
  'settings.prompt.payload.sg.model_persona': 'model character description (account_description)',
  'settings.prompt.payload.sg.recent_messages': 'array of recent messages [{role, text}]',
  'settings.prompt.payload.sg.media_hint': 'media hint (if selling content) or null',
  'settings.prompt.payload.sg.send_delay_min_seconds': 'min delay before sending (seconds)',
  'settings.prompt.payload.sg.send_delay_max_seconds': 'max delay before sending (seconds)',
  'settings.prompt.payload.mo.payment_score': 'payment readiness (spending_intent)',
  'settings.prompt.payload.mo.relationship_score': 'relationship level (emotional_attachment)',
  'settings.prompt.payload.mo.sexual_level': 'sexual tension',
  'settings.prompt.payload.mo.days_since_last_purchase': 'days since last purchase',
  'settings.prompt.payload.mo.resistance_level': 'resistance level',
  'settings.prompt.payload.mo.price_sensitivity': 'price sensitivity',
  'settings.prompt.payload.mo.purchase_count': 'number of purchases from this fan',
  'settings.prompt.payload.mo.state': 'current state (FLIRT, PRESELL, etc.)',
  'settings.prompt.payload.mo.allow_offer': 'whether offer is allowed (Core decision)',
  'settings.prompt.payload.dg.media_info': 'media metadata (price_min, price_max, description)',
  'settings.prompt.payload.dg.client_context': 'client context for personalization',
  'settings.prompt.payload.dg.current_state': 'fan\'s current state',
  'settings.prompt.payload.dg.spending_intent_score': 'spending intent',
  'settings.prompt.payload.dg.price_sensitivity': 'price sensitivity',
  'settings.prompt.payload.dg.relationship_summary': 'relationship summary (user_profile)',
  'settings.prompt.payload.dg.tone_style': 'tone style',
  'settings.prompt.payload.dg.explicit_level': 'explicitness level',
  'settings.prompt.payload.dg.model_persona': 'model persona',
  'settings.prompt.payload.dg.incoming_messages': 'incoming messages (array of elements)',
  'settings.prompt.payload.og.user_profile': 'fan profile (memory_summary output)',
  'settings.prompt.payload.og.media_info': 'media group with description (price_min, price_max, description)',
  'settings.prompt.payload.og.model_persona': 'model persona',
  'settings.prompt.payload.og.incoming_messages': 'last N conversation messages (array of {role, text})',
  'settings.prompt.payload.ms.existing_user_profile': 'current fan profile (what we already know)',
  'settings.prompt.payload.ms.recent_messages': 'recent messages from the conversation',
  'settings.prompt.payload.ps.candidate_reply_preview': 'reply preview for safety check',
  'settings.prompt.payload.ps.explicit_level': 'explicitness level',
  'settings.prompt.payload.ps.tone_style': 'tone style',
  'settings.prompt.payload.ps.message_length': 'message length',
  'settings.prompt.payload.pmg.state': 'current state (for follow-up)',
  'settings.prompt.payload.pmg.recent_messages': 'recent messages in the conversation',
  'settings.prompt.payload.pmg.model_persona': 'model persona',
  'settings.prompt.payload.pmg.tone_style': 'tone style',
  'settings.prompt.payload.pmg.explicit_level': 'explicitness level',
  'settings.conditionalPrompts.title': 'Additional prompts (by condition)',
  'settings.conditionalPrompts.hint': 'Add extra text to the main prompt when numerical parameters meet the condition. Use simple (param, op, value) or complex (AND/OR) conditions.',
  'settings.conditionalPrompts.conditionLabel': 'Condition (numerical parameters):',
  'settings.conditionalPrompts.promptLabel': 'Additional text (appended to main prompt):',
  'settings.conditionalPrompts.roleLabel': 'Role:',
  'settings.conditionalPrompts.orderLabel': 'Order:',
  'settings.conditionalPrompts.addRule': '+ Add conditional prompt',
  'settings.conditionalPrompts.promptPlaceholder': 'Text to append when condition is met',
  'settings.condition.simple': 'Simple',
  'settings.condition.complex': 'Complex (AND/OR)',
  'settings.condition.plainBoolTrue': 'Always true',
  'settings.condition.plainBoolFalse': 'Always false',
  'settings.condition.plainBoolDefaultHint': 'Not set in JSON — backend treats this as true (advance after free send).',
  'settings.condition.plainBoolForceTrue': 'Set: always true',
  'settings.condition.plainBoolForceFalse': 'Set: always false',
  'settings.condition.switchToExpression': 'Use condition (DSL)…',
  'settings.condition.clearToBackendDefault': 'Remove key (use backend default)',
  'settings.condition.addCondition': '+ Add condition',
  'settings.condition.and': 'and',
  'settings.condition.or': 'or',
  'params.title': 'Parameters',
  'params.engagement_score': 'Engagement',
  'params.emotional_attachment_score': 'Emotional attachment',
  'params.sexual_tension_score': 'Sexual tension',
  'params.spending_intent_score': 'Spending intent',
  'params.resistance_level': 'Resistance',
  'params.price_sensitivity': 'Price sensitivity',
  'params.risk_of_churn': 'Churn risk',
  'params.content_readiness_score': 'Content readiness',
  'params.intimacy_score': 'Intimacy',
  'params.total_messages_in_chat': 'Total messages',
  'params.total_fan_messages': 'Fan messages',
  'params.messages_in_current_session': 'Messages in current session',
  'params.session_length_minutes': 'Session length (min)',
  'params.messages_7d': 'Messages (7d)',
  'params.days_since_last_message': 'Days since last message',
  'params.total_spend': 'Total spend',
  'params.spend_30d': 'Spend (30d)',
  'params.purchase_count': 'Purchase count',
  'params.ever_bought': 'Ever bought',
  'params.days_since_last_purchase': 'Days since last purchase',
  'params.offer_accept_rate': 'Offer accept rate',
  'params.ghost_after_offer_rate': 'Ghost after offer rate',
  'params.recent_offer_rejected': 'Recent offer rejected',
  'params.preferred_tone': 'Preferred tone',
  'params.content_preferences': 'Content preferences',
  'params.buyer_style_hint': 'Buyer style',
  'params.conversation_style_hint': 'Conversation style',
  'params.messages_since_offer': 'Messages since offer',
  'params.relationship_stage': 'Relationship stage',
  'params.monetization_stage': 'Monetization stage',
  'params.conversation_state': 'Scenario state',
  'params.proactive_trigger': 'Proactive trigger',
  'params.fan_came_online': 'Fan came online',
  'params.fan_is_online': 'Fan is online',
  'params.fan_started_typing': 'Fan started typing',
  'params.fan_liked_post': 'Fan liked a post',
  'params.fan_commented_post': 'Fan commented on a post',
  'params.sale_script_allowed': 'Sale script allowed',
  'params.direct_offer_allowed': 'Direct offer allowed',
  'params.upsell_allowed': 'Upsell allowed',
  'params.cooldown_after_offer': 'Cooldown after offer',
  'settings.hasSettings': 'Has settings',
  'settings.noSettings': 'No settings',
  'settings.node.label.in': 'Incoming message',
  'settings.node.label.core': 'Core',
  'settings.node.label.media_selector': 'Media Selector',
  'settings.node.label.send': 'Send',
  'settings.nodeHint.in': 'Only receives incoming messages. No settings required.',
  'settings.nodeHint.core': 'L3 params (engagement, spending_intent, etc.) are computed from L1 (analyzer) + L2. All logic — in Variables section.',
  'settings.nodeHint.coreGoToVariables': '→ Variables, level L3',
  'settings.nodeHint.media_selector': 'Selects media by script. Settings — in media section.',
  'settings.nodeDesc.in': 'Incoming node: debounce merges messages into one input; TTL prevents stuck tasks; save retry — retries on save failure. Conversation messages count — in each agent\'s settings.',
  'settings.nodeDesc.core': 'Core updates L3 params from analyzer signals (signal→delta, clamp 0–100). Transitions — via conditions in Edges.',
  'settings.core.graphTransitionsHeading': 'Monetization guard: postbuy_block (shown below the numeric Core settings)',
  'settings.nodeDesc.media_selector': '',
  'settings.mediaSelector.intro': 'Media Selector picks media depending on branch (chat or sales). Core sets allow_offer from run_monetization; emit_chat_media gates free chat media. Free-only script stages can surface as sales-shaped hints without offer_generator — see advance_script_on_free_send.',
  'settings.mediaSelector.salesTitle': 'Sales branch (trigger_offer + allow_offer)',
  'settings.mediaSelector.salesSessionTitle': 'Photo session selection',
  'settings.mediaSelector.salesSession1': 'Take current session from profile (current_script_session_id).',
  'settings.mediaSelector.salesSession2Before': 'Switch when: no current session; or session time_tag ≠ current time of day (morning 6–11, day 12–17, evening 18–22, night 23–5) and ≥ ',
  'settings.mediaSelector.salesSession2After': ' h; otherwise keep.',
  'settings.mediaSelector.salesSession3': 'When choosing: prefer time_tag (model timezone), else last_chat_session_id.',
  'settings.mediaSelector.salesGroupTitle': 'Group selection within session',
  'settings.mediaSelector.salesGroup1': 'Only script sessions (is_script=True) with groups (price_min, price_max).',
  'settings.mediaSelector.salesGroup2': 'Order: MediaGroup.sort_order → group_sort_order → session_sort_order → id.',
  'settings.mediaSelector.routingHeading': 'Routing (sales vs chat)',
  'settings.mediaSelector.salesGroup3': 'current_script_stage_index selects the stage (MediaGroup in script order). Advances +1 after a terminal event: free-only stage → successful outbound send (configurable); paid/mixed → payment webhook.',
  'settings.mediaSelector.chatTitle': 'Chat branch (no offer)',
  'settings.mediaSelector.chat1': 'Exclude script sessions (is_script=True).',
  'settings.mediaSelector.chat2Before': 'Exclude media sent to fan in last ',
  'settings.mediaSelector.chat2After': ' days.',
  'settings.mediaSelector.chat3': 'Limit: L3 intimacy_score → max_hotness (0–20→3, 20–40→5, 40–60→7, 60–80→8, 80+→10).',
  'settings.mediaSelector.chat4': 'Sort: hotness DESC, updated_at DESC.',
  'settings.mediaSelector.chat5': 'Take first matching media (single, not group).',
  'settings.mediaSelector.transitionTitle': 'Transition to sales branch',
  'settings.mediaSelector.transitionText': 'run_monetization condition (block below). True → offer_generator → policy_safety → send. False → message_generator → policy_safety → send.',
  'settings.nodeDesc.send': 'Send delay range (min/max/default), typing indicator, retry on API error.',
  'settings.params': 'params',
  'settings.edgesHint': 'Condition for the sales branch from Core. If true — Media Selector → offer_generator; if false — message_generator. Format: param, operator, value, AND/OR.',
  'settings.variablesHint': 'L4 variables for conditions (transitions, conditional_prompts). If empty — params + L2. If set — only L4.',
  'settings.variables.definitions': 'Variable definitions',
  'settings.variables.definitionsDesc': '',
  'settings.variables.empty': 'Empty. Using params + L2 (backward compatibility).',
  'settings.variables.key': 'Key',
  'settings.variables.type': 'Type',
  'settings.variables.range': 'Range',
  'settings.variables.purpose': 'Purpose',
  'settings.variables.source': 'Source',
  'settings.variables.levelL1': 'L1',
  'settings.variables.levelL2': 'L2',
  'settings.variables.levelL3': 'L3',
  'settings.variables.levelL4': 'L4',
  'settings.variables.l1Title': 'L1 — analyzer output',
  'settings.variables.l1Desc': 'Read-only. Message analyzer output (intent, tone, scores).',
  'settings.variables.l2Title': 'L2 — DB variables',
  'settings.variables.l2Desc': 'Read-only. Computed on each graph run.',
  'settings.variables.l3Title': 'L3 — Core params',
  'settings.variables.l3DescHardcoded': 'Read-only. Hardcoded 9 params (0–100). Formula: prev + observed_delta from L1, clamp 0–100. Available in L4 as source_type: l3.',
  'settings.variables.l3.howItWorks': 'How it works',
  'settings.variables.l3.howItWorksContent': `1. Direct deltas (signal → param +N / −N)
Most params: L1 sends signal (compliment_detected, intent, emotion, etc.), Core adds or subtracts. Deltas capped ±15 per step (max_delta). Configured in «Other» (signal_delta_*).

2. Blend — content_readiness_score
Not a simple sum. raw_llm = value after signal deltas. computed = engagement×0.2 + sexual_tension×0.35 + intimacy×0.3 − resistance×0.15. Result: blended = raw_llm×0.4 + computed×0.6 (40% raw + 60% formula). Prevents extreme jumps.

3. Conditional decisions — allow_offer, risk_flag
allow_offer: hardcoded (see block below). risk_flag = true → SAFETY_LOCK.

4. Constraints for Message Generator
From params: intimacy_level, pressure, tone, length, explicit_level, allow_offer. Passed to Message Generator.

5. Counters and phases
messages_since_offer, ignored_question_counter, failed_offer_counter, postbuy_phase — in profile.parameters. postbuy_phase: delivery → aftercare. Transitions — via conditions in Edges.`,
  'settings.variables.l3.calc.engagement_score': 'Formula: new = prev + delta, result 0–100. Delta per message capped at ±max_delta.\n\nDelta contributions (summed, then clamp ±max_delta):\n  trust_score (0–100) from analyzer → round((score−50)×scale), e.g. 65→+3, 40→−2\n  intent: greeting, small_talk → +2\n  intent: compliment, answered_questions → +3 or +4\n  intent: reengagement → +5\n  emotion: excited → +4\n  emotion: playful → +2\n  emotion: cold → −3\n  compliment_detected → +3\n  ignored_question → −3\n  ignored_question_counter ≥ 3 (L2) → −2',
  'settings.variables.l3.calc.emotional_attachment_score': 'Formula: new = prev + delta, 0–100. Delta ±max_delta per message.\n\nContributions:\n  attachment_score from analyzer → round((score−50)×scale)\n  intent: compliment, reengagement → +4..+5\n  emotion: affectionate, warm, needy, jealous → +2..+4\n  compliment_detected → +5\n  topic_shift_personal → +4\n  emotion: cold → −2\n  attachment_signal (0–5) → ×2',
  'settings.variables.l3.calc.sexual_tension_score': 'Formula: new = prev + delta, 0–100. Delta ±max_delta per message.\n\nContributions:\n  sexual_tension_score, user_arousal_score from analyzer → round((score−50)×scale)\n  intent: flirt → +4\n  intent: sexual_escalation → +6\n  emotion: horny, playful → +3..+5\n  asked_content, flirt_positive_response → +3..+5\n  sexual_intent_level (0–5) → ×1.2',
  'settings.variables.l3.calc.spending_intent_score': 'Formula: new = prev + delta, 0–100. Delta ±max_delta per message.\n\nContributions:\n  spending_score from analyzer → round((score−50)×scale)\n  intent: request_content, buy_intent → +4..+6\n  intent: price_check → +3\n  asked_content → +4\n  objection_or_resistance → −3\n  topic_shift_price → +3\n  payment_signal (0–5) → ×2\n  failed_offer_counter ≥ 2 (L2) → −2',
  'settings.variables.l3.calc.resistance_level': 'Formula: new = prev + delta, 0–100. Delta ±max_delta per message.\n\nContributions:\n  resistance_score from analyzer → round((score−50)×scale)\n  intent: angry, complaint → +6..+8\n  emotion: frustrated, defensive → +4\n  objection_or_resistance → +6\n  ignored_question → +2\n  ignored_question_counter ≥ 3 (L2) → +2\n  failed_offer_counter ≥ 2 (L2) → +3',
  'settings.variables.l3.calc.price_sensitivity': 'Default 50. No direct deltas from signals. Configurable via graph_settings (signal_delta_*).',
  'settings.variables.l3.calc.risk_of_churn': 'Formula: new = prev + delta, 0–100. Delta ±max_delta per message.\n\nContributions:\n  intent: reengagement → −5\n  intent: jealous, angry, inactive, complaint → +2..+5\n  emotion: frustrated, jealous → +2\n  objection_or_resistance → +3',
  'settings.variables.l3.calc.content_readiness_score': 'Formula: blend(raw_llm, computed), 0–100.\n\nL1 deltas (like other params): user_arousal_score, intent sexual_escalation/request_content/buy_intent, asked_content, emotion_horny, buy_intent_signal, sexual_intent_level.\n\nBlend after deltas:\n  raw_llm → value after L1\n  computed → engagement×0.2 + sexual_tension×0.35 + intimacy×0.3 − resistance×0.15\n  result → raw_llm×0.4 + computed×0.6, clamp 0–100',
  'settings.variables.l3.calc.intimacy_score': 'Formula: new = prev + delta, 0–100. Delta ±max_delta per message.\n\nContributions:\n  intent: flirt → +3\n  emotion: affectionate, warm → +2..+3\n  compliment_detected, flirt_positive_response → +4\n  topic_shift_personal → indirect\n  attachment_signal (0–5) → ×1.5',
  'settings.variables.l3.subTabParams': 'Params',
  'settings.variables.l3.derivedSection': 'Core derived values',
  'settings.variables.l3.derivedDesc': 'allow_offer, risk_flag. Transition conditions — in «Edges».',
  'settings.variables.l3.derived.allow_offer': 'allow_offer',
  'settings.variables.l3.derived.allow_offer.calc': 'Effective allow_offer in Core: postbuy_block runs first (if configured and true → allow_offer false), then run_monetization from «Edges». In single-condition preview, use «Evaluate» and read the «Core monetization outcome» block. Conditions may use messages_since_offer, postbuy_phase, etc.',
  'settings.variables.l3.derived.risk_flag': 'risk_flag',
  'settings.variables.l3.derived.risk_flag.calc': 'Derived bool: policy_risk_score ≥ policy_risk_safety_lock_threshold (threshold in Core settings) → risk_flag; risk_flag = true → SAFETY_LOCK, graph exits without reply.',
  'settings.variables.l3.derived.constraints': 'Constraints',
  'settings.variables.l3.derived.constraints.calc': 'allow_offer — for Monetization and Media. tone_style, explicit_level — for Description Generator and Policy Safety. Not passed to Message Generator — customization via L4.',
  'settings.variables.l3.derived.counters': 'Counters (profile.parameters)',
  'settings.variables.l3.derived.counters.calc': 'compliment_counter, ignored_question_counter, messages_since_offer, failed_offer_counter, reengagement_counter, flirt_response_counter.\n  Updated from L1 signals: compliment_detected, ignored_question, flirt_positive_response, reengagement. last_offer_failed → +1 failed_offer_counter.\n  messages_since_offer: +1 if allow_offer=false, else 0. Used in deltas (ignored_question_counter≥3 → engagement−2, resistance+2; failed_offer_counter≥2 → resistance+3, spending−2). Purchase count is in L2 (purchase_count).',
  'settings.variables.l3.derived.postbuy_phase': 'postbuy_phase',
  'settings.variables.l3.derived.postbuy_phase.calc': 'After purchase: delivery → aftercare. Transition to COOLDOWN — via conditions in Edges.',
  'settings.variables.l3Empty': 'Empty. L3 available in L4 as source_type: l3.',
  'settings.variables.sourceParam': 'param',
  'settings.variables.sourceL2': 'l2',
  'settings.variables.sourceL3': 'l3',
  'settings.variables.sourceKey': 'Source key',
  'settings.variables.typeInt': 'int',
  'settings.variables.typeFloat': 'float',
  'settings.variables.typeBool': 'bool',
  'settings.variables.typeEnum': 'enum',
  'settings.variables.keyPlaceholder': 'variable_name',
  'settings.variables.namePlaceholder': 'Name (in conditions)',
  'settings.variables.enumValuePlaceholder': 'value',
  'settings.variables.addEnumValue': 'Add value',
  'settings.variables.addBlock': 'Add variable',
  'settings.variables.deleteVariableTitle': 'Delete variable?',
  'settings.variables.deleteVariableMessage': 'Variable «{key}» will be deleted.',
  'settings.variables.deleteConditionTitle': 'Delete condition?',
  'settings.variables.deleteConditionMessage': 'Condition (value «{value}») will be deleted.',
  'settings.variables.add': 'Add',
  'settings.variables.addVariable': 'Add variable',
  'settings.variables.editVariable': 'Edit variable',
  'settings.variables.conditions': 'conditions',
  'settings.variables.condition': 'Condition',
  'settings.variables.result': 'Result',
  'settings.variables.resultTrue': 'true',
  'settings.variables.resultFalse': 'false',
  'settings.variables.valueConditions': 'value_conditions',
  'settings.variables.useDefaults': 'Use defaults',
  'settings.variables.clear': 'Clear',
  'settings.variables.l2.total_messages_in_chat': 'total conversation volume',
  'settings.variables.l2.total_fan_messages': 'messages sent by user',
  'settings.variables.l2.messages_in_current_session': 'current session length',
  'settings.variables.l2.session_length_minutes': 'current session duration (min)',
  'settings.variables.l2.messages_7d': 'activity in 7 days',
  'settings.variables.l2.days_since_last_message': 'days since last message',
  'settings.variables.l2.total_spend': 'total spend',
  'settings.variables.l2.spend_30d': 'spend in 30 days',
  'settings.variables.l2.purchase_count': 'number of purchases',
  'settings.variables.l2.ever_bought': 'has ever purchased',
  'settings.variables.l2.days_since_last_purchase': 'days since last purchase',
  'settings.variables.l2.offer_accept_rate': 'offer accept rate',
  'settings.variables.l2.ghost_after_offer_rate': 'ghost after offer rate',
  'settings.variables.l2.recent_offer_rejected': 'recent offer rejected',
  'settings.variables.l2.preferred_tone': 'preferred communication tone',
  'settings.variables.l2.content_preferences': 'preferred content types',
  'settings.variables.l2.buyer_style_hint': 'buyer style',
  'settings.variables.l2.conversation_style_hint': 'conversation style',
  'settings.variables.l2.messages_since_offer': 'messages since offer',
  'settings.variables.l2.relationship_stage': 'relationship stage',
  'settings.variables.l2.monetization_stage': 'monetization stage',
  'settings.variables.l2.conversation_state': 'current scenario state',
  'settings.variables.l2.sale_script_allowed': 'sale script allowed',
  'settings.variables.l2.direct_offer_allowed': 'direct offer allowed',
  'settings.variables.l2.upsell_allowed': 'upsell allowed',
  'settings.variables.l2.cooldown_after_offer': 'cooldown after offer',
  'settings.variables.l2.current_state': 'Core state (profile.current_state, e.g. POSTBUY)',
  'settings.variables.l2.postbuy_phase': 'POSTBUY phase (delivery, payment_pending, aftercare)',
  'settings.variables.l2.proactive_trigger': 'event that started proactive evaluation',
  'settings.variables.l2.fan_came_online': 'true when the provider reports the fan came online',
  'settings.variables.l2.fan_is_online': 'true when the provider reports the fan is online',
  'settings.variables.l2.fan_started_typing': 'true when the provider reports typing',
  'settings.variables.l2.fan_liked_post': 'true when the provider reports a post like',
  'settings.variables.l2.fan_commented_post': 'true when the provider reports a post comment',
  'settings.variables.l2.physical_item_interest_score': 'confidence in a shipped physical-item request',
  'settings.variables.l2.physical_item_active': 'true while the physical-item review route is active',
  'settings.variables.l2.support_interest_score': 'confidence in a voluntary support or gift offer',
  'settings.variables.l2.support_route_active': 'true while an approved support route is active',
  'settings.variables.l2.dominant_style_score': 'confidence in an explicit power-dynamic preference',
  'settings.variables.l2.dominant_style_preference': 'explicit requested power-dynamic direction or stop signal',
  'settings.variables.l2.dominant_style_active': 'true only after explicit consent to the adaptive dominant style',
  'settings.variables.l2.timewaster_strategy_active': 'true only for an enabled long unpaid high-tension conversation with low spend intent',
  'settings.transition.coreToMonetization': 'Core → sales branch',
  'settings.transition.coreToMonetizationHint': 'Condition for the sales branch.',
  'settings.transition.salesBranch': 'Transition to sales branch',
  'settings.transition.salesBranchHint': 'When condition is true — take the sales branch (Media Selector → offer_generator → policy_safety → send). When false — take the chat branch (message_generator → policy_safety → send). If condition is not set — always chat branch.',
  'settings.transition.emitChatMedia': 'Free chat media (emit_chat_media)',
  'settings.transition.emitChatMediaHint': 'When false — Media Selector does not attach free chat media (text only). When true — chat media allowed. If not set — allowed (fail-open).',
  'settings.transition.postbuyBlock': 'POSTBUY block for monetization',
  'settings.transition.postbuyBlockHint': 'When true — Core sets allow_offer=false regardless of run_monetization (PPV fatigue during fulfillment). Omit for fail-open.',
  'settings.transition.advanceScriptOnFreeSend': 'Advance script cursor on free send',
  'settings.transition.advanceScriptOnFreeSendHint': 'When true (default), free-only script stages advance +1 after a successful outbound send (idempotent by outbound id). Use «Switch to expression» for a DSL; parameters include current_state and postbuy_phase.',
  'settings.executor.title': 'Executor / delivery',
  'settings.executor.intro': 'All keys below are read by the backend executor (graph_config_service, delivery, media selector). No hidden settings.',
  'settings.llmFallback.title': 'LLM fallback',
  'settings.llmFallback.desc': 'Controls the model used for one-shot retries and optional manual fallback circuit activation.',
  'settings.llmFallback.active': 'Active',
  'settings.llmFallback.inactive': 'Inactive',
  'settings.llmFallback.activate': 'Activate circuit',
  'settings.llmFallback.clear': 'Clear circuit',
  'settings.llmFallback.current': 'Current fallback',
  'settings.llmRouter.title': 'LLM routing by state',
  'settings.llmRouter.desc': 'Overrides the agent model by conversation state. Empty rows inherit the agent model.',
  'settings.llm.selectModel': 'Select model',
  'settings.llm.inheritModel': 'Inherit agent model',
  'settings.key.llm_fallback_to_grok_enabled': 'Enable LLM fallback',
  'settings.desc.llm_fallback_to_grok_enabled': 'Allows automatic one-shot retries and manual circuit fallback when the primary provider fails.',
  'settings.key.llm_fallback_grok_model': 'Fallback model',
  'settings.desc.llm_fallback_grok_model': 'The model used for fallback retries. It may be OpenAI, fine-tuned OpenAI, MiniMax, or Grok.',
  'settings.key.llm_state_model_router_enabled': 'Enable state router',
  'settings.key.bot_policy_safety_enabled': 'LLM moderator',
  'settings.desc.bot_policy_safety_enabled': 'Enables policy_safety before sending. When disabled, the LLM moderator is skipped, while local outbound validation still runs.',
  'settings.key.timewaster_strategy_enabled': 'Enable timewaster handling',
  'settings.desc.timewaster_strategy_enabled': 'Opt-in strategy for long unpaid high-tension conversations with low spend intent.',
  'settings.key.timewaster_min_fan_messages': 'Fan-message threshold',
  'settings.desc.timewaster_min_fan_messages': 'Minimum incoming fan messages before the strategy can activate.',
  'settings.key.timewaster_high_tension_min': 'High tension minimum',
  'settings.desc.timewaster_high_tension_min': 'Minimum sexual tension score required for the value-boundary prompt.',
  'settings.key.timewaster_low_spend_intent_max': 'Low spend intent maximum',
  'settings.desc.timewaster_low_spend_intent_max': 'Highest spend intent score still treated as low purchase intent.',
  'settings.key.timewaster_reply_delay_min_seconds': 'Minimum slowed reply, seconds',
  'settings.desc.timewaster_reply_delay_min_seconds': 'Lower bound of the random reply delay while active.',
  'settings.key.timewaster_reply_delay_max_seconds': 'Maximum slowed reply, seconds',
  'settings.desc.timewaster_reply_delay_max_seconds': 'Upper bound of the random reply delay while active.',
  'settings.condition.previewTitle': 'Condition preview (sample JSON params)',
  'settings.condition.previewPasteHint':
    'Paste flat JSON from «Copy flat JSON for condition preview» in message logs, or any log object with condition_preview / l3+l4. For nested logs, pick snapshot below (after ≈ Core decision).',
  'settings.condition.previewPhaseLabel': 'Snapshot for l3/l4:',
  'settings.condition.previewPhaseAfter': 'after (end of step)',
  'settings.condition.previewPhaseBefore': 'before (start of step)',
  'settings.condition.previewEvaluate': 'Evaluate',
  'settings.condition.previewResult': 'Result (this condition only)',
  'settings.condition.previewInvalidJson': 'Invalid JSON',
  'settings.condition.monetizationGateTitle': 'Core monetization outcome (same as Core)',
  'settings.condition.monetizationPostbuyBlock': 'postbuy_block',
  'settings.condition.monetizationRunMonetization': 'run_monetization',
  'settings.condition.monetizationAllowOfferEffective': 'allow_offer (effective)',
  'media.group.validation.pricedNeedsPaid': 'Paid price range requires at least one media with is_paid.',
  'media.group.validation.freeGroupHasPaid': 'Free group (0–0) cannot contain is_paid media.',
  'media.group.validation.noPreviewHint': 'Paid group has no free preview item — OF may show fully locked bundle.',
  'chats.funnel.title': 'Funnel diagnostics',
  'chats.funnel.loading': 'Loading profile…',
  'chats.funnel.error': 'Could not load bot profile',
  'chats.funnel.buyerStyle': 'Buyer style',
  'chats.funnel.conversationStyle': 'Conversation style',
  'chats.funnel.adaptiveStyle': 'Adaptive communication style',
  'chats.funnel.style.active': 'active',
  'chats.funnel.style.noData': 'not enough data',
  'chats.funnel.style.confidence': 'Style confidence',
  'chats.funnel.style.directness': 'Directness',
  'chats.funnel.style.warmth': 'Warmth need',
  'chats.funnel.style.playfulness': 'Playfulness',
  'chats.funnel.style.detail': 'Detail preference',
  'chats.funnel.style.pace': 'Pace',
  'settings.transition.coreToScriptGenerator': 'Core → Message Generator',
  'settings.transition.coreToScriptGeneratorHint': 'When sales branch condition is false — take the chat branch.',
  'settings.transition.useDefault': 'Use default',
  'settings.selectSection': 'Select a section in the menu.',
  'settings.nodesHint': 'Pipeline nodes. Click node on diagram to edit.',
  'settings.diagramClickHint': 'Click to edit',
  'settings.agentNotFound': 'agent not found',
  'settings.nodeNotFound': 'node not found',
  'settings.edgeNotFound': 'edge not found',
  'settings.renderError': 'Render error',

  // Graph diagram
  'diagram.loading': 'Loading graph…',
  'diagram.in': 'In',
  'diagram.messageAnalyzer': 'Message Analyzer',
  'diagram.memorySummarizer': 'Memory Summarizer',
  'diagram.llmAgents': 'LLM agents',
  'diagram.messageGenerator': 'Message Generator',
  'diagram.contentModerator': 'Content Moderator',
  'diagram.offerGenerator': 'Offer Generator',
  'diagram.ruleBased': 'Rule-based',
  'diagram.core': 'Core',
  'diagram.mediaSelector': 'Media Selector',
  'diagram.send': 'Send',
  'diagram.incomingMessage': 'Incoming message',
  'diagram.parallel': 'parallel',
  'diagram.memorySummarizerEvery10': 'Memory Summarizer (every 10 msg)',
  'diagram.sendSale': 'Send (sale)',
  'diagram.sendChat': 'Send (chat, can include media)',
  'diagram.parallelNote': 'Message Analyzer and Memory Summarizer run in parallel, wait for each other → Core',
  'diagram.proactiveFlow': 'Proactive bot',
  'diagram.proactiveBot': 'Proactive bot',
  'diagram.proactiveGenerator': 'Proactive generator',

  // Setting key labels (settings.key.<key>)
  'settings.key.bot_debounce_seconds': 'Debounce (sec)',
  'settings.key.bot_running_graph_ttl_seconds': 'Running graph TTL (sec)',
  'settings.key.bot_pending_task_ttl_seconds': 'Pending task TTL (sec)',
  'settings.key.bot_delayed_send_ttl_seconds': 'Delayed send TTL (sec)',
  'settings.key.bot_send_delay_min_ms': 'Min pre-send delay (ms)',
  'settings.key.bot_send_delay_max_ms': 'Max pre-send delay (ms)',
  'settings.key.bot_send_delay_default_ms': 'Default pre-send delay (ms)',
  'settings.key.bot_typing_indicator_enabled': 'Typing indicator (1/0)',
  'settings.key.bot_send_retry_attempts': 'Max send retries',
  'settings.key.bot_send_retry_backoff_ms': 'Retry backoff base (ms)',
  'settings.key.bot_send_split_enabled': 'Split long sends (1/0)',
  'settings.key.bot_send_split_max_chunk_length': 'Split: max chars per chunk',
  'settings.key.bot_send_split_inter_chunk_delay_seconds': 'Split: delay between chunks (sec)',
  'settings.key.bot_send_split_max_chunks': 'Split: max chunks per message',
  'settings.key.bot_send_strict_paid_invariants': 'Strict paid media invariants (1/0)',
  'settings.key.bot_save_retry_delay_seconds': 'Save retry delay (sec)',
  'settings.key.bot_save_retry_max_attempts': 'Max save retries',
  'settings.key.policy_risk_safety_lock_threshold': 'Policy risk safety lock threshold',
  'settings.key.bot_core_score_delta_scale': 'Scale multiplier (score -> delta)',
  'settings.key.bot_core_max_delta': 'Max delta per message (max_delta)',
  'settings.key.bot_context_messages_count': 'Context messages count',
  'settings.key.message_analyzer_conversation_messages_count': 'Analyzer conversation messages',
  'settings.key.bot_silence_followup_rapport_hours': 'Follow-up RAPPORT (h)',
  'settings.key.bot_silence_followup_rapport_returned_hours': 'Follow-up RAPPORT returned (h)',
  'settings.key.bot_silence_followup_flirt_hours': 'Follow-up FLIRT (h)',
  'settings.key.bot_silence_followup_presell_hours': 'Follow-up PRESELL (h)',
  'settings.key.bot_silence_followup_offer_hours': 'Follow-up OFFER (h)',
  'settings.key.bot_silence_followup_postbuy_hours': 'Follow-up POSTBUY (h)',
  'settings.key.bot_silence_followup_cooldown_hours': 'Follow-up COOLDOWN (h)',
  'settings.key.bot_session_switch_min_hours': 'Session switch min hours (h)',
  'settings.key.bot_chat_media_recent_days': 'Chat media: recent (days)',
  // Setting descriptions (settings.desc.<key>)
  'settings.desc.bot_debounce_seconds': 'Wait before running the graph after the last message. All messages in this window are merged into one input.',
  'settings.desc.bot_running_graph_ttl_seconds': 'TTL for the "graph running" key in Redis. Protects against stuck tasks.',
  'settings.desc.bot_pending_task_ttl_seconds': 'TTL for the debounce queue task. If the graph has not started by then — task is cancelled.',
  'settings.desc.bot_delayed_send_ttl_seconds': 'TTL for delayed send. If a new message arrives in this time — send is cancelled, new graph runs.',
  'settings.desc.bot_send_delay_min_ms': 'Random pre-send delay lower bound (uniform).',
  'settings.desc.bot_send_delay_max_ms': 'Random pre-send delay upper bound (uniform).',
  'settings.desc.bot_send_delay_default_ms': 'Fallback when suggested_delay_seconds is outside min/max.',
  'settings.desc.bot_typing_indicator_enabled': 'If 1, typing API runs before send (and during delayed countdown).',
  'settings.desc.bot_send_retry_attempts': 'Retries on 429/5xx/network after delayed send fires.',
  'settings.desc.bot_send_retry_backoff_ms': 'Exponential backoff base between retries.',
  'settings.desc.bot_send_split_enabled': 'If 1, long outbound text is split into multiple provider sends.',
  'settings.desc.bot_send_split_max_chunk_length': 'Maximum characters per chunk when split is enabled.',
  'settings.desc.bot_send_split_inter_chunk_delay_seconds': 'Pause between chunks (human-like pacing).',
  'settings.desc.bot_send_split_max_chunks': 'Safety cap: stop after this many chunks.',
  'settings.desc.bot_send_strict_paid_invariants': 'If 1, block sends when price/media slots contradict OF rules.',
  'settings.key.bot_typing_duration_seconds': 'Typing indicator duration (sec)',
  'settings.key.bot_typing_interval_seconds': 'Typing repeat interval (sec)',
  'settings.key.bot_typing_chars_per_call': 'Chars per extra typing call',
  'settings.desc.bot_typing_duration_seconds': 'One API typing call shows indicator for approximately this many seconds.',
  'settings.desc.bot_typing_interval_seconds': 'How often to repeat typing call for long delays.',
  'settings.desc.bot_typing_chars_per_call': 'Every N message characters triggers an extra typing call.',
  'settings.desc.bot_save_retry_delay_seconds': 'Pause between DB save retries on error.',
  'settings.desc.bot_save_retry_max_attempts': 'Max DB save attempts.',
  'settings.desc.policy_risk_safety_lock_threshold': 'If policy_risk_score >= this value, risk_flag is set and graph transitions to SAFETY_LOCK (no reply). 0–100.',
  'settings.desc.bot_core_score_delta_scale': 'Default: 0.2. Formula for analyzer scores: delta = (score - 50) * scale.',
  'settings.desc.bot_core_max_delta': 'Default: 15. Maximum parameter change per step for L3 params.',
  'settings.desc.bot_context_messages_count': 'How many recent chat messages to pass to the LLM as context.',
  'settings.desc.message_analyzer_conversation_messages_count': 'How many last conversation messages to pass to the analyzer (conversation_history). Editable in settings, used in prompt as {{conversation_messages_count}}.',
  'settings.desc.message_generator_conversation_messages_count': 'How many last messages to pass to message_generator (recent_messages in payload).',
  'settings.desc.memory_summary_conversation_messages_count': 'How many last messages to pass to memory_summary (recent_messages in payload).',
  'settings.key.memory_summary_run_every_n_messages': 'Run every N messages',
  'settings.desc.memory_summary_run_every_n_messages': 'Memory summarizer runs when fan\'s messages_processed_count crosses a multiple of N (10, 20, 30…). Default 10.',
  'settings.desc.proactive_message_generator_conversation_messages_count': 'How many last messages to pass to proactive_message_generator (recent_messages in payload).',
  'settings.desc.offer_generator_conversation_messages_count': 'How many last messages to pass to offer_generator (incoming_messages in payload).',
  'settings.desc.bot_silence_followup_rapport_hours': 'Hours of silence before sending follow-up in RAPPORT (new fan).',
  'settings.desc.bot_silence_followup_rapport_returned_hours': 'Hours of silence before sending follow-up in RAPPORT (fan returned after pause).',
  'settings.desc.bot_silence_followup_flirt_hours': 'Hours of silence before sending follow-up in FLIRT.',
  'settings.desc.bot_silence_followup_presell_hours': 'Hours of silence before sending follow-up in PRESELL.',
  'settings.desc.bot_silence_followup_offer_hours': 'Hours of silence before sending follow-up in OFFER.',
  'settings.desc.bot_silence_followup_postbuy_hours': 'Hours of silence before sending follow-up in POSTBUY.',
  'settings.desc.bot_silence_followup_cooldown_hours': 'Hours of silence before sending follow-up in COOLDOWN.',
  'settings.desc.bot_session_switch_min_hours': 'Minimum hours between photo session switches. Formula: switch if (current_session.time_tag ≠ current_time_tag) AND (elapsed_hours ≥ N), where elapsed_hours = (now − last_script_session_changed_at) / 3600. Prevents "gave session, fan writes 10 min later — already different".',
  'settings.desc.bot_chat_media_recent_days': 'How many days to consider media "recently sent" to fan. Exclude from selection media sent in last N days. Formula: recent_cutoff = now − N days.',
  // Models list
  'models.title': 'Models',
  'models.add': '+ Add model',
  'models.loading': 'Loading…',
  'models.empty': 'No models yet. Add the first one.',
  'models.account.ok':
    'Model is used for messaging and sales — account description is filled',
  'models.account.bad':
    'Model is not yet used for messaging or sales — fill in the account description',
  'models.account.bad.prefix': 'Model is not yet used for messaging or sales — ',
  'models.account.bad.description': 'fill in the account description',
  'models.account.bad.timezone': 'fill in the timezone',
  'models.account.bad.both': 'fill in the description and timezone',
  'models.connection.edit': 'Edit connection',
  'models.connection.info': 'Info & connection history',
  'models.connection.delete': 'Delete',
  'models.connection.connected': 'Connected',
  'models.connection.connecting': 'Connecting…',
  'models.connection.pending': 'Not connected',
  'models.connection.stop': 'Stop connection',
  'models.connection.unlink':
    'Unlink (only in our app, provider connection stays)',
  'models.connection.connect': 'Connect',
  'models.connectModal.titleCreate': 'Add model',
  'models.connectModal.titleEdit': 'Edit connection',
  'models.connectModal.password': 'Password',
  'models.connectModal.passwordUnchangedPlaceholder': 'Leave blank to keep unchanged',
  'models.connectModal.testModel': 'Test model (for automated tests)',
  'models.connectModal.validationRequiredCreate': 'Enter email and password',
  'models.connectModal.validationRequiredEdit': 'Enter email',
  'models.twoFa.descriptionWithModel':
    'Model: {model}. Enter the 2FA code if it is enabled on the OnlyFans account.',
  'models.twoFa.description':
    'Enter the 2FA code if two-factor authentication is enabled on the account.',
  'models.twoFa.connect': 'Connect',
  'models.twoFa.label': '2FA (optional)',
  'models.twoFa.placeholder': 'Code from authenticator app',
  'models.delete.title': 'Delete model?',
  'models.delete.message':
    'Model "{name}", all provider connections, media and all related data will be deleted. This action cannot be undone.',
  'models.disconnect.title': 'Disconnect provider?',
  'models.disconnect.message':
    'Link {provider} for model "{model}" will be deleted only in our app. Provider connection will stay — on reconnect it will be reused automatically.',
  'models.disconnect.confirm': 'Disconnect',
  'models.disconnect.progress': 'Disconnecting…',
  'models.onlyfansapi.2fa.title': 'OnlyFans API connection',

  // Model detail
  'modelDetail.backToList': '← Back to list',
  'modelDetail.fallbackName': 'Model',
  'modelDetail.sync.progress': 'Syncing…',
  'modelDetail.sync.done': 'Synced',
  'modelDetail.sync.error': 'Error',
  'modelDetail.account.ok':
    'Model is used for messaging and sales — account description is filled',
  'modelDetail.account.bad':
    'Model is not yet used for messaging or sales — fill in the account description',
  'modelDetail.account.bad.prefix': 'Model is not yet used for messaging or sales — ',
  'modelDetail.account.bad.description': 'fill in the account description',
  'modelDetail.account.bad.timezone': 'fill in the timezone',
  'modelDetail.account.bad.both': 'fill in the description and timezone',
  'modelDetail.loading': 'Loading…',
  'modelDetail.account.loading': 'Loading account data…',
  'modelDetail.account.sectionLabel': 'Account',
  'modelDetail.account.name': 'Name',
  'modelDetail.account.username': 'Username',
  'modelDetail.account.email': 'Email',
  'modelDetail.account.subscribePrice': 'Subscription price ($)',
  'modelDetail.account.credits': 'Credits (min–max)',
  'modelDetail.account.subscribers': 'Subscribers',
  'modelDetail.account.posts': 'Posts',
  'modelDetail.account.localDescription': 'Description (local)',
  'modelDetail.account.timezone': 'Timezone',
  'modelDetail.account.timezone.label': 'Timezone',
  'modelDetail.account.timezone.placeholder': 'Start typing, e.g.: Europe/London',
  'modelDetail.account.defaultConfig.label': 'Default graph config',
  'modelDetail.account.defaultConfig.hint': 'Used when a new chat profile is created for this model.',
  'modelDetail.account.editAria': 'Edit account description',
  'modelDetail.account.delete.title': 'Delete model?',
  'modelDetail.account.delete.message':
    'Model "{name}", all provider connections, media and all related data will be deleted. This action cannot be undone.',
  'modelDetail.account.description.modalTitle': 'Account description',
  'modelDetail.account.description.label': 'Account description',
  'modelDetail.account.description.placeholder':
    'Free-form account description for internal use',
  'modelDetail.account.description.saveError':
      'Failed to save account description',
  'modelDetail.account.maxMessagePrice.label': 'Max message price (PPV), $',
  'modelDetail.account.maxMessagePrice.placeholder': 'empty — default from settings',
  'modelDetail.account.maxMessagePrice.hint': 'Integer in range 3–200. Empty — use the value from global bot settings.',
  'modelDetail.account.maxMessagePrice.invalid': 'Price must be an integer in range 3–200 (or empty).',
  'modelDetail.connectionHistory.title': 'Connection history',
  'modelDetail.connectionHistory.empty': 'No events',

  // Media
  'media.used.ok':
    'Media is used — all parameters are filled, everything is ok',
  'media.used.bad':
    'Media is not yet used for messaging or sales — fill in description, hotness and body parts',
  'media.used.notActive': 'Media is not active.',
  'media.used.excluded': 'Media is excluded from automatic use.',
  'media.used.fillPrompt': 'Fill in:',
  'media.used.missing.price': 'price',
  'media.used.missing.description': 'description',
  'media.used.missing.hotness': 'hotness',
  'media.used.missing.bodyParts': 'body parts',
  'media.type.video': 'Video',
  'media.type.audio': 'Audio',
  'media.type.photo': 'Photo',
  'media.type.gif': 'GIF',
  'media.type.unknown': 'Unknown type',
  'media.count.photo': 'Photos: {count}',
  'media.count.video': 'Videos: {count}',
  'media.count.audio': 'Audio: {count}',
  'media.count.gif': 'GIF: {count}',
  'media.count.unknown': 'Unknown: {count}',
  'media.composition.hint': 'Composition of loaded media in this step',
  'media.library.remove': 'Remove from library',
  'media.library.confirm': 'Confirm library change',
  'media.library.restore': 'Restore to library',
  'media.library.removeHint': 'Remove this item from the FanLTV library and block bot delivery, including in scripts. The original on the platform and purchase history remain unchanged. You can restore it using Show hidden.',
  'media.library.restoreHint': 'Restore this item to the library. Automatic use stays disabled until you explicitly enable it in media settings.',
  'media.library.removed': 'Removed from FanLTV library. Platform original kept.',
  'media.library.restored': 'Restored to library. Automatic use stays disabled.',
  'media.library.error': 'Could not confirm the library change. Refresh the list before retrying.',
  'media.library.providerMissing': 'Restore the original at the provider, then run a full sync.',
  'media.library.removeFromScript': 'Remove from script',
  'media.library.removeFromScriptHint': 'Remove from script only. The file stays in the library.',
  'media.loading': 'Loading…',
  'media.loadingError': 'Load error',
  'media.noPreview': 'No preview',
  'media.queue': 'Queued',
  'media.error': 'Error',
  'media.section.photosets': 'Photos & videos',
  'media.section.audio': 'Audio',
  'media.section.media': 'Media',
  'media.sync.stop': 'Stop',
  'media.sync.stop.title': 'Stop sync',
  'media.sync.media': 'Sync media',
  'media.sync.media.needOfApi': 'Connect OnlyFans API',
  'media.sync.loading': 'Loading media…',
  'media.downloadAll': 'Download full content',
  'media.downloadAll.title': 'Download all media',
  'media.downloadAll.confirmTitle': 'Download full content of all media?',
  'media.downloadAll.confirmMessage': 'Only media that are not yet downloaded will be queued. Cost: ~$1 per 300 MB. Download is charged by OnlyFans API.',
  'media.downloadAll.queued': 'Queued: {count} media',
  'media.downloadQueue.hint': 'Updates in real time without refresh',
  'media.downloadQueue.queued': 'In queue: {count}',
  'media.downloadQueue.downloading': 'Downloading: {count}',
  'media.downloadQueue.downloadingAndQueued': 'Downloading: {downloading}, in queue: {queued}',
  'media.stats.downloadedOfTotal': 'Downloaded: {downloaded} of {total}',
  'media.stats.inQueue': 'In queue: {count}',
  'media.select.hint': 'Click circle to select',
  'media.none': 'No media',
  'media.selectedCount': 'Selected: {count}',
  'media.session.name.placeholder': 'Photoset name',
  'media.session.createAndMove': 'Create photoset and move',
  'media.session.creating': 'Creating photoset…',
  'media.session.none': 'No photoset',
  'media.session.noneOption': 'No photoset',
  'media.session.createOption': '➕ Create photoset…',
  'media.move': 'Move',
  'media.moving': 'Moving…',
  'media.selection.clear': 'Clear selection',
  'media.session.edit.title': 'Configure photoset',
  'media.session.edit.nameLabel': 'Name',
  'media.session.edit.namePlaceholder': 'Photoset name',
  'media.session.edit.descriptionLabel': 'Script description',
  'media.session.edit.descriptionPlaceholder': 'When to use this scenario: mood, vibe, visible content, best fan request.',
  'media.session.edit.descriptionHint': 'Used by the bot to choose the right script from conversation context. Step and media descriptions are still used too.',
  'media.session.edit.tagsLabel': 'Selection tags',
  'media.session.edit.tagsPlaceholder': 'red dress, garden, feet, soft tease',
  'media.session.edit.tagsHint': 'Comma-separated. Use words a fan may naturally write.',
  'media.session.edit.timeOfDayLabel': 'Time of day',
  'media.session.edit.timeOfDayPlaceholder': '— not selected —',
  'media.session.edit.isScriptLabel': 'Script',
  'media.session.scriptLabel': 'Script',
  'media.session.scriptTooltip': 'Media from this photoset are sold sequentially.',
  'media.session.active.ok': 'Photoset is active — time of day is set',
  'media.session.active.bad': 'Photoset is not active — set time of day',
  'media.session.unassignedGroup': 'No photoset',
  'media.session.unmarkedLabel': 'Unmarked',
  'media.section.unmarked': 'Unmarked',
  'media.session.delete.title': 'Delete photoset',
  'media.session.delete.message': 'Delete photoset «{name}»? Media will move to unassigned.',
  'media.group.add': 'Add group',
  'media.group.addShort': 'Group',
  'media.group.namePlaceholder': 'Group name',
  'media.group.unnamed': 'Unnamed',
  'media.group.ungrouped': 'No group',
  'media.group.edit.title': 'Edit group',
  'media.group.edit.titleUngrouped': 'Price for «No group»',
  'media.group.description': 'Step description',
  'media.group.description.placeholder':
    'Describe the whole step: what the buyer gets, sales angle, and any usage notes.',
  'media.group.price.guideTitle': 'Price and description levels',
  'media.group.price.guideText':
    'Use media edit for a single item description or individual media price. Use group edit for the whole step description and stage price.',
  'media.group.price.edit': 'Set step price and description',
  'media.group.price.editShort': 'Edit step',
  'media.group.price.setShort': 'Set price',
  'media.group.delete.title': 'Delete group?',
  'media.group.delete.message': 'Delete group «{name}»?\nMedia will stay in the photoset.',
  'media.group.reorder': 'Drag to reorder group',
  'media.group.readyForSale': 'Group is ready for sale',
  'media.group.missingForSale': 'Fill in the group price',
  'media.group.notReadyForSale': 'Group is not ready for sale',
  'media.reorder.tip': 'Drag to reorder',
  'media.timeOfDay.any': 'Any',
  'media.timeOfDay.morning': 'Morning',
  'media.timeOfDay.day': 'Day',
  'media.timeOfDay.evening': 'Evening',
  'media.timeOfDay.night': 'Night',
  'media.category.selfie': 'Selfie',
  'media.category.everyday_photo': 'Everyday photo',
  'media.category.teaser': 'Teaser',
  'media.category.explicit': 'Explicit',
  'media.category.voice_phrase': 'Voice phrase',
  'media.excluded.badge': 'Do not use',
  'media.audio.untitled': 'Untitled audio',
  'media.audio.source.prerecorded': 'Prerecorded',
  'media.audio.source.onlyfans': 'OnlyFans',
  'media.audio.voice.short': 'Voice',
  'media.audio.onlyfans.title': 'Audio from account',
  'media.audio.onlyfans.empty': 'No synced account audio yet.',
  'media.audio.phrases.title': 'Prerecorded phrases',
  'media.audio.phrases.empty': 'No prerecorded phrases yet.',
  'media.audio.upload.title': 'Title',
  'media.audio.upload.titlePlaceholder': 'Short label for the phrase',
  'media.audio.upload.text': 'Phrase text',
  'media.audio.upload.textPlaceholder': 'What this audio says',
  'media.audio.voice.label': 'Cloned voice',
  'media.audio.voice.placeholder': 'voice_id or provider voice name',
  'media.audio.upload.file': 'Audio file',
  'media.audio.upload.submit': 'Upload phrase',
  'media.audio.upload.saved': 'Audio phrase uploaded',
  'media.audio.upload.error': 'Failed to upload audio phrase',

  // Media edit modal
  'media.edit.modal.title': 'Media parameters',
  'media.edit.modal.error': 'Save error',
  'media.edit.isPaidLabel': 'Paid',
  'media.edit.excludedFromAutoUse': 'Do not use automatically',
  'media.paid': 'Paid',
  'media.free': 'Free',
  'media.edit.mediaPrice': 'Individual media price ($)',
  'media.edit.mediaPriceHint':
    'Use this only when this media has its own PPV price. Stage/group price is edited on the group.',
  'media.edit.price': 'Price ($)',
  'media.edit.priceRangeAria': 'Price range',
  'media.edit.priceMinAria': 'Min price ${value}',
  'media.edit.priceMaxAria': 'Max price ${value}',
  'media.edit.description': 'Description',
  'media.edit.description.placeholder':
    'Describe what is in the photo/video — bot uses it to sell content',
  'media.edit.category': 'Category',
  'media.edit.category.none': 'No category',
  'media.edit.hotness': 'Hotness (1–10)',
  'media.edit.notSelected': 'Not selected',
  'media.edit.bodyParts': 'Body parts',
  'media.edit.bodyParts.add': 'Add {label}',
  'media.edit.bodyParts.remove': 'Remove {label}',
  'media.edit.bodyParts.face': 'Face',
  'media.edit.bodyParts.chest': 'Chest',
  'media.edit.bodyParts.butt': 'Butt',
  'media.edit.bodyParts.pussy': 'Pussy',
  'media.edit.bodyParts.legs': 'Legs',

  // Media viewer
  'media.viewer.fileNotUploaded': 'File is not uploaded',
  'media.viewer.loadError': 'Load error',
  'media.viewer.accessError': 'Failed to get access',
  'media.viewer.imageError': 'Failed to load image',
  'media.viewer.aria.view': 'Media viewer',
  'media.viewer.aria.close': 'Close',
  'media.viewer.loading': 'Loading…',

  // Chats
  'chats.title': 'Chats',
  'chats.tab.real': 'Real',
  'chats.tab.test': 'Test',
  'chats.addTestChat': '+ Test chat',
  'chats.addTestChat.modalTitle': 'Add test chat',
  'chats.addTestChat.fanName': 'Test fan name',
  'chats.addTestChat.fanNamePlaceholder': 'test_fan',
  'chats.addTestChat.selectModel': 'Select model',
  'chats.addTestChat.needModel': 'Select a model first',
  'chats.addTestChat.config': 'Configuration',
  'chats.addTestChat.selectConfig': 'Select configuration',
  'chats.addTestChat.configActive': 'Active',
  'chats.addTestChat.active': 'active',
  'chats.config.openSettings': 'Configuration settings',
  'chats.editTestChat.title': 'Edit test chat',
  'chats.simulate.message': 'Message from fan',
  'chats.simulate.messagePlaceholder': 'Message text…',
  'chats.simulate.send': 'Send',
  'chats.simulate.attachPhoto': 'Attach photo',
  'chats.simulate.attachAudio': 'Attach voice message',
  'chats.voiceMessage': 'Voice message',
  'chats.purchase.buy': 'Buy',
  'chats.purchase.purchased': 'Purchased — media from library',
  'chats.attachments.multiSwipe': 'Scroll sideways to see every file in this message',
  'chats.attachments.loadMediaTitle': 'Load media in this message (faster chat open)',
  'chats.attachments.redactedItem': '{type} sent - preview hidden',
  'chats.attachments.redactedSummary': '{count} creator media item(s) sent. Hidden in tester mode.',
  'chats.testBadge': 'Test',
  'chats.modelFilter.placeholder': 'Filter by model',
  'chats.toModel': 'To model →',
  'chats.loadingModels': 'Loading models…',
  'chats.loading': 'Loading…',
  'chats.sidebar.loading': 'Loading…',
  'chats.sidebar.empty':
    'No chats yet. Messages will appear after OnlyFans API webhooks.',
  'chats.modelFallback': 'Model #{id}',
  'chats.noMessages': 'No messages',
  'chats.typing': 'Model is typing…',
  'chats.selectLeft': 'Select a chat on the left',
  'chats.thread.loading': 'Loading thread…',
  'chats.error.load': 'Failed to load chats',
  'chats.error.microphone': 'Microphone access denied',
  'chats.error.fileTooLarge': 'File is too large (max 10 MB)',
  'chats.filter.type': 'Type',
  'chats.filter.action': 'Action',
  'chats.filter.model': 'Model',
  'chats.filter.status': 'Status',
  'chats.filter.allModels': '— All models —',
  'chats.filter.showBlocked': 'Blocked',
  'chats.filter.showAll': 'All chats',
  'chats.manual.enable': 'Manual mode',
  'chats.manual.disable': 'Auto bot',
  'chats.manual.enable.title': 'Enable manual mode?',
  'chats.manual.enable.message':
    'Bot will stop processing this chat while manual mode is enabled. Continue?',
  'chats.manual.disable.title': 'Disable manual mode?',
  'chats.manual.disable.message':
    'Bot will resume automatic processing for this chat. Continue?',
  'chats.manualSend.placeholder': 'Write as the model...',
  'chats.manualSend.send': 'Send reply',
  'chats.manualSend.enableHint': 'Enable manual mode to answer from this cabinet.',
  'chats.manualSend.error': 'Failed to send manual reply',
  'chats.subscription.active': 'Active subscriber',
  'chats.delete.action': 'Delete chat',
  'chats.delete.title': 'Delete chat completely?',
  'chats.delete.message':
    'This will remove messages, state, graphs, logs, analytics and related bot context for this chat. This action cannot be undone.',
  'chats.safetyLock.badge': 'Blocked by safety',
  'chats.safetyLock.unlock': 'Unlock',
  'chats.safetyLock.unlockTitle': 'Unlock this chat?',
  'chats.safetyLock.unlockMessage':
    'Automatic lock for this chat will be removed and bot processing can resume. Continue?',
  'chats.logs.title': 'Logs',
  'chats.logs.messageId': 'message_id: {id}',
  'chats.logs.close': 'Close',
  'chats.logs.loading': 'Loading…',
  'chats.logs.empty': 'No logs found',
  'chats.logs.emptyList': 'No logs with messages',
  'chats.logs.noPreview': '—',
  'chats.logs.selectHint': 'Select a log from the list or click an outgoing message',
  'chats.logs.error': 'Failed to load log',
  'chats.logs.incomingOnly': 'Logs are available only for outgoing bot messages',
  'chats.logs.openHint': 'Open message logs',
  'chats.logs.incomingHint': 'Incoming messages do not have graph logs',
  'chats.logs.graph': 'Graph',
  'chats.logs.nodes': 'Nodes',
  'chats.logs.aiCalls': 'AI calls',
  'chats.logs.parameters': 'Parameter changes',
  'chats.logs.paramsBefore': 'Before',
  'chats.logs.paramsAfter': 'After',
  'chats.logs.paramsChanges': 'Changes',
  'chats.logs.paramsL3': 'L3 (counters)',
  'chats.logs.paramsL4': 'L4 (scenario)',
  'chats.logs.paramsNoChanges': 'No changes in this step',
  'chats.logs.copyConditionPreview': 'Copy flat JSON for condition preview',
  'chats.logs.monetizationSummaryTitle': 'Core outcome (constraints)',
  'chats.logs.monetizationSummaryAllowOffer': 'allow_offer',
  'chats.logs.monetizationSummaryAllowChatMedia': 'allow_chat_media',
  'chats.logs.conditionPreviewSource.core_snapshot': 'Condition preview JSON: exact Core snapshot (run_monetization / emit_chat_media context).',
  'chats.logs.conditionPreviewSource.legacy_merged_after': 'Condition preview JSON: approximate (L3/L4 after + current_state); new graphs get exact snapshot.',
  'chats.logs.rawParameterJson': 'Parameter details',
  'chats.logs.agents': 'Agents and nodes',
  'chats.logs.noAgents': 'No data',
  'chats.logs.nodeLabel.in': 'Incoming message',
  'chats.logs.nodeLabel.core': 'Core',
  'chats.logs.nodeLabel.core_brain': 'Core',
  'chats.logs.nodeLabel.media_selector': 'Media Selector',
  'chats.logs.nodeLabel.send': 'Send',
  'chats.logs.nodeLabel.policy_safety_action': 'Moderator action',
  'chats.logs.nodeLabel.parallel_analyzer_memory': 'Analyzer + Memory Summary',
  'chats.logs.status': 'Status',
  'chats.logs.input': 'Input',
  'chats.logs.output': 'Output',
  'chats.logs.request': 'Request',
  'chats.logs.response': 'Response',
  'chats.logs.duration': 'Duration',
  'chats.logs.durationWithDelay': 'Duration with delay',
  'chats.logs.delaySeconds': 'delay {n} s',
  'chats.logs.stateTransition': 'State',
  'chats.logs.rawData': 'Raw graph data',
  'chats.logs.safetyLockBanner': 'Reply blocked (SAFETY_LOCK)',
  'chats.logs.safetyLockReason': 'Reason: {reason}',
  'chats.logs.failedReason': 'Failure reason:',
  'chats.logs.safetyLockHint': 'Analyzer returned risk_flag → graph completed without sending a message.',

  // Analytics
  'analytics.title': 'Analytics',
  'analytics.loading': 'Loading analytics…',
  'analytics.empty': 'No snapshots found',
  'analytics.recompute.action': 'Recompute',
  'analytics.recompute.running': 'Recomputing…',
  'analytics.scope.label': 'Scope',
  'analytics.scope.all': 'All scopes',
  'analytics.scope.global': 'Global',
  'analytics.scope.model': 'Model',
  'analytics.scope.fanModel': 'Fan+Model',
  'analytics.snapshot.label': 'Snapshot type',
  'analytics.snapshot.all': 'All types',
  'analytics.snapshot.fanStates': 'Fan states',
  'analytics.snapshot.revenue': 'Revenue',
  'analytics.snapshot.performance': 'Bot performance',
  'analytics.snapshot.openaiCost': 'OpenAI cost',
  'analytics.snapshot.fanProfile': 'Fan profile',
  'analytics.model.label': 'Model',
  'analytics.model.all': '— Select model —',
  'analytics.fanModel.placeholder': 'fan_model scope_id, e.g. 12:3',
  'analytics.table.computedAt': 'Computed at',
  'analytics.table.scope': 'Scope',
  'analytics.table.type': 'Type',
  'analytics.table.period': 'Period',
  'analytics.table.data': 'Data',
  'analytics.table.open': 'Open details',

  // Fans / purchases table (ModelDataPage)
  'modelData.fans.title': 'Fans',
  'modelData.fans.model': 'Model',
  'modelData.fans.name': 'Name',
  'modelData.fans.username': 'Username',
  'modelData.fans.id': 'ID',
  'modelData.fans.test': 'Test',
  'modelData.fans.createdAt': 'Created at',
  'modelData.chats.title': 'Chats',
  'modelData.chats.direction': 'Direction',
  'modelData.chats.fan': 'Fan',
  'modelData.chats.messageId': 'Message ID',
  'modelData.chats.createdAt': 'Created',
  'modelData.chats.incoming': '← Incoming',
  'modelData.chats.outgoing': '→ Outgoing',
  'modelData.purchases.title': 'Purchases',
  'modelData.purchases.model': 'Model',
  'modelData.purchases.fan': 'Fan',
  'modelData.purchases.type': 'Type',
  'modelData.purchases.amount': 'Amount',
  'modelData.purchases.createdAt': 'Created',
  'modelData.filterByModel': 'Filter by model',
  'modelData.toModel': 'To model →',
  'modelData.loadingModels': 'Loading models…',
  'modelData.loading': 'Loading…',
  'modelData.allModels': '— All models —',
  'modelData.allTypes': 'All (test+real)',
  'modelData.selectModel': 'Select model',
  'modelData.total': 'Total: {count}',
  'modelData.noData': 'No data',

  // Error boundary
  'errorBoundary.title': 'Something went wrong',
  'errorBoundary.unknown': 'Unknown error',
  'errorBoundary.retry': 'Try again',

  // Generic API errors (fallbacks)
  'errors.model.create': 'Failed to create model',
  'errors.profile.load': 'Failed to load profile',
  'errors.account.load': 'Failed to load account data',
  'errors.account.update': 'Failed to update account description',
  'errors.reconnect.start': 'Failed to start reconnect',
  'errors.connect.start': 'Failed to start connection',
  'errors.connect.cancel': 'Failed to cancel connection',
  'errors.media.load': 'Failed to load media',
  'errors.media.update': 'Failed to update media',
  'errors.media.sync.start': 'Failed to start sync',
  'errors.media.sync.stop': 'Failed to stop sync',
  'errors.media.downloadAll': 'Failed to queue download',
  'errors.media.token': 'Failed to get token',
  'errors.session.create': 'Failed to create photoset',
  'errors.session.move': 'Failed to move',
  'errors.session.generic': 'Failed to create session',
  'errors.generic.save': 'Failed to save',
  'errors.media.download': 'Media load error',
  'errors.media.sync': 'Sync error',
  'errors.media.stoppedByUser': 'Stopped by user',
  'errors.access': 'Access failed',
  'errors.sessionExpired': 'Session expired',
  'errors.request': 'Request error',

  // Logs page (bot execution logs)
  'logs.title': 'Graph run logs',
  'logs.subtitle': 'Logs of each graph run — from incoming message or proactive follow-up',
  'logs.modelFilter': 'Model',
  'logs.statusFilter': 'Status',
  'logs.status.all': 'All',
  'logs.status.COMPLETED': 'Completed',
  'logs.status.FAILED': 'Failed',
  'logs.status.ROLLBACK': 'Rollback',
  'logs.status.RUNNING': 'Running',
  'logs.status.WAITING_LLM': 'Waiting LLM',
  'logs.status.PENDING': 'Pending',
  'logs.loading': 'Loading logs…',
  'logs.empty': 'No logs found',
  'logs.error': 'Failed to load logs',
  'logs.selectLeft': 'Select a log from the list',
  'logs.initiatedBy': 'Initiated by',
  'logs.initiatedBy.fan': 'Fan message',
  'logs.initiatedBy.system': 'System',
  'logs.detailTitle': 'Log detail',
  'logs.graphId': 'Graph ID',
  'logs.back': 'Back',

  // Logs sub-nav
  'logs.nav.graphs': 'Graphs',
  'logs.nav.proactive': 'Proactive bot',

  // Proactive logs page
  'logs.proactive.title': 'Logs of proactive bot runs',
  'logs.proactive.subtitle': 'History of silence follow-up runs. «With agent runs» — only runs where the agent was launched.',
  'logs.proactive.runsCount': 'Runs: {count}',
  'logs.proactive.graphsCount': 'Graphs: {count}',
  'logs.proactive.agentRunsCount': 'Agent runs: {count}',
  'logs.proactive.agentRunsOfRun': 'Agent runs ({count})',
  'logs.proactive.noAgentRunsInRun': 'No runs',
  'logs.proactive.selectAgentRunHint': 'Select a run, then an agent run per fan.',
  'logs.proactive.selectAgentRunFromList': 'Select an agent run from the list',
  'logs.proactive.backToAgentRuns': 'Back to list',
  'logs.proactive.agentRun': 'Agent run',
  'logs.proactive.empty': 'No runs',
  'logs.proactive.toGraphLogs': '→ To graph logs',
  'logs.proactive.runsList': 'Runs',
  'logs.proactive.selectRun': 'Select a run',
  'logs.proactive.graphsOfRun': 'Graphs of run ({count})',
  'logs.proactive.noGraphsInRun': 'No graphs found',
  'logs.proactive.selectRunHint': 'Select a run on the left',
  'logs.proactive.selectGraphHint': 'Then select a graph to view its log',
  'logs.proactive.selectGraphFromList': 'Select a graph from the list on the left',
  'logs.proactive.backToGraphs': 'Back to graphs',
  'logs.proactive.openInGraphLogs': 'Open in graph logs',
  'logs.proactive.trigger.silence_followup': 'Silence follow-up',
  'logs.proactive.trigger.unknown': 'System',
  'logs.proactive.filter.label': 'Runs',
  'logs.proactive.filter.all': 'All',
  'logs.proactive.filter.withAgentRuns': 'With agent runs',
  'logs.proactive.pagination.range': '{from}–{to} of {total}',
  'logs.proactive.pagination.page': 'Page {n}',

  // Restored classic / agency settings keys
  'layout.nav.agencySettings': 'Agency settings',
  'login.remember': 'Remember me',
  'login.titleUnified': 'Sign in',
  'common.copied': 'Copied',
  'common.refresh': 'Refresh',
  'chats.export.chatHistory': 'Export chat history',
  'chats.loadEarlier': 'Load earlier',
  'chats.logs.copyLog': 'Copy log',
  'chats.simulate.recordAudio': 'Record audio',
  'chats.simulate.stopRecording': 'Stop recording',
  'chats.simulate.uploading': 'Uploading...',
  'media.session.reorder': 'Reorder',
  'settings.config.activateBlocked': 'Fix validation errors before activating this configuration.',
  'settings.variables.deleteConditionGroupMessage': 'Delete this condition group?',
  'modelDetail.account.automation.fullAuto': 'Full auto',
  'modelDetail.account.automation.handoffOnOffer': 'Handoff on offer',
  'modelDetail.account.automation.handoffAfterFirstPurchase': 'Handoff after first purchase',
  'modelDetail.account.telegram.tokenHint': 'Paste a new token only when you need to replace the saved one.',
  'users.billing.plan.monthly_flat': 'Monthly flat',
  'users.billing.plan.per_bot_message': 'Per bot message',
  'users.billing.plan.revenue_share': 'Revenue share',
  'users.billing.plan.hybrid': 'Hybrid',
  'users.billing.plan.custom': 'Custom',

  'agencySettings.title': 'Agency settings',
  'agencySettings.hint': 'Manage model setup, safe graph controls, proactive rules and reactivation workflows.',
  'agencySettings.tabs.label': 'Section',
  'agencySettings.tabs.models': 'Models',
  'agencySettings.tabs.l4': 'L4 variables',
  'agencySettings.tabs.proactive': 'Proactive',
  'agencySettings.tabs.timewasters': 'Timewasters',
  'agencySettings.tabs.customPricing': 'Custom pricing',
  'agencySettings.tabs.monetizationRoutes': 'Monetization routes',
  'agencySettings.tabs.prompt': 'Prompt controls',
  'agencySettings.tabs.reactivation': 'Reactivation',
  'agencySettings.tabs.transitions': 'Transitions',
  'agencySettings.tabs.conditionalPrompts': 'Conditional prompts',
  'agencySettings.tabs.engineApi': 'Engine API',
  'agencySettings.tabs.mcp': 'MCP setup',
  'agencySettings.tabs.onboarding': 'Onboarding',
  'agencySettings.onboarding.title': 'Guided model setup',
  'agencySettings.onboarding.hint': 'Connect accounts, add a brief, review AI suggestions, audit old chats, configure voice and products, then test the exact version.',
  'agencySettings.onboarding.safety': 'Only your assigned models are accessible. Drafts do not change live replies, and publishing never resumes a paused bot.',
  'agencySettings.onboarding.open': 'Start or resume onboarding',
  'agencySettings.engineApi.title': 'FanLTV Engine API',
  'agencySettings.engineApi.hint': 'Connect an external platform without reducing FanLTV to a single-message reply endpoint. Sync context continuously and request decisions only when FanLTV should act.',
  'agencySettings.engineApi.clientName': 'Integration name',
  'agencySettings.engineApi.callbackUrl': 'Callback URL (optional)',
  'agencySettings.engineApi.defaultMode': 'Default mode',
  'agencySettings.engineApi.create': 'Create API client',
  'agencySettings.engineApi.revoke': 'Revoke',
  'agencySettings.engineApi.empty': 'No Engine API clients yet.',
  'agencySettings.engineApi.credentialsOnce': 'Save these credentials now. They are shown only once.',
  'agencySettings.engineApi.created': 'Engine API client created',
  'agencySettings.engineApi.revoked': 'Engine API client revoked',

  'agencySettings.billing.plan': 'Plan',
  'agencySettings.billing.balance': 'Balance',
  'agencySettings.billing.lowBalanceThreshold': 'Low balance threshold',
  'agencySettings.billing.rate': 'Rate',
  'agencySettings.billing.sent30d': 'Sent 30d',
  'agencySettings.billing.messages30d': 'Billable 30d',
  'agencySettings.billing.amount30d': 'Amount 30d',
  'agencySettings.billing.available': 'Available messages',

  'agencySettings.models.settingsTitle': 'Model operating settings',
  'agencySettings.models.settingsHint': 'Set profile, timezone, automation mode and operator alerts per model.',
  'agencySettings.models.model': 'Model',
  'agencySettings.models.connection': 'Connection',
  'agencySettings.models.description': 'Profile description',
  'agencySettings.models.descriptionHint': 'Persona, tone, boundaries, sales style and account context.',
  'agencySettings.models.descriptionPlaceholder': 'Describe the model voice, limits and sales style.',
  'agencySettings.models.timezone': 'Timezone',
  'agencySettings.models.timezoneHint': 'Used for proactive timing and quiet hours.',
  'agencySettings.models.timezonePlaceholder': 'America/New_York',
  'agencySettings.models.automation': 'Automation',
  'agencySettings.models.automationMode': 'Automation mode',
  'agencySettings.models.automationModeHint': 'Controls how much the bot can do without operator approval.',
  'agencySettings.models.defaultConfig': 'Default graph config',
  'agencySettings.models.defaultConfigHint': 'Used for new conversations when the chat has no explicit config.',
  'agencySettings.models.defaultConfigActive': 'Use active global config',
  'agencySettings.models.defaultConfigActiveBadge': 'active',
  'agencySettings.models.botStatus': 'Bot status',
  'agencySettings.models.botPaused': 'Paused',
  'agencySettings.models.botActive': 'Live',
  'agencySettings.models.pauseBot': 'Pause bot',
  'agencySettings.models.resumeBot': 'Resume bot',
  'agencySettings.models.profileReady': 'Profile ready',
  'agencySettings.models.profileMissing': 'Profile missing',
  'agencySettings.models.telegram': 'Telegram alerts',
  'agencySettings.models.telegramEnabled': 'Enable Telegram alerts',
  'agencySettings.models.telegramEnabledHint': 'Send operational events to an external Telegram chat.',
  'agencySettings.models.telegramChatId': 'Telegram chat ID',
  'agencySettings.models.telegramChatIdHint': 'Chat, group or channel ID that receives alerts.',
  'agencySettings.models.telegramChatIdPlaceholder': '-100...',
  'agencySettings.models.telegramToken': 'Telegram bot token',
  'agencySettings.models.telegramTokenPlaceholder': 'Paste token to set or replace',
  'agencySettings.models.telegramTokenSet': 'Token is saved',
  'agencySettings.models.telegramEvents': 'Alert events',
  'agencySettings.models.telegramSetupTitle': 'Telegram setup',
  'agencySettings.models.telegramSetupStep1': 'Create a bot with BotFather.',
  'agencySettings.models.telegramSetupStep2': 'Add it to the operator chat.',
  'agencySettings.models.telegramSetupStep3': 'Paste the token and chat ID here.',
  'agencySettings.models.save': 'Save model settings',
  'agencySettings.models.saved': 'Model settings saved',
  'agencySettings.models.saveError': 'Failed to save model settings',
  'agencySettings.models.enabled': 'Enabled',
  'agencySettings.models.disabled': 'Disabled',
  'agencySettings.models.empty': 'No models available.',
  'agencySettings.models.event.state_changed': 'State changed',
  'agencySettings.models.event.low_balance': 'Low balance',
  'agencySettings.models.event.handoff_on_offer': 'Handoff on offer',
  'agencySettings.models.event.handoff_after_first_purchase': 'Handoff after first purchase',
  'agencySettings.models.event.purchase': 'Confirmed purchases',
  'agencySettings.models.event.insufficient_credit': 'Insufficient credit',
  'agencySettings.models.event.graph_failed': 'Graph failed',
  'agencySettings.models.event.openai_timeout': 'OpenAI timeout',

  'agencySettings.config.copy': 'Configuration copy',
  'agencySettings.config.copyHint': 'Agency edits are saved into the selected safe configuration copy.',
  'agencySettings.config.copyActive': 'Copy active config',
  'agencySettings.config.copied': 'Configuration copy created',
  'agencySettings.config.copyError': 'Failed to copy configuration',
  'agencySettings.config.saved': 'Configuration saved',
  'agencySettings.config.saveError': 'Failed to save configuration',
  'agencySettings.config.transitions': 'Graph transitions',
  'agencySettings.config.transitionsHint': 'Safe transition conditions available to agency operators.',
  'agencySettings.l4.title': 'L4 variables',
  'agencySettings.l4.hint': 'Business-level variables that can be used in transition and proactive conditions.',
  'agencySettings.proactive.rulesTitle': 'Follow-up rules',
  'agencySettings.proactive.rulesHint': 'First matching rule determines when a proactive follow-up is eligible.',
  'agencySettings.proactive.cadenceTitle': 'Cadence controls',
  'agencySettings.proactive.webhooksTitle': 'Provider event triggers',
  'agencySettings.promptControls.title': 'Prompt controls',
  'agencySettings.customPricing.title': 'Custom content pricing',
  'agencySettings.customCapabilities.title': 'Custom production capabilities',
  'agencySettings.customCapabilities.modelScopeTitle': 'Choose the model first',
  'agencySettings.customCapabilities.modelScopeHint': 'Custom capabilities and prices are stored in the graph config assigned to the selected model.',
  'agencySettings.customCapabilities.modelLabel': 'Model whose custom settings you are editing',
  'agencySettings.customCapabilities.editingModel': 'Editing model',
  'agencySettings.customCapabilities.assignedConfig': 'Assigned graph config',
  'agencySettings.customCapabilities.globalConfigWarning': 'This model uses the active global config. Saving here also changes every model that uses the global config.',
  'agencySettings.customCapabilities.sharedConfigWarning': 'This graph config is shared by several models. Saving here changes custom settings for all of them.',
  'agencySettings.customCapabilities.exclusiveConfig': 'This graph config is assigned only to this model.',
  'agencySettings.customCapabilities.changeAssignmentHint': 'To change the assigned config, open Models and update Default graph config for this model.',
  'agencySettings.customCapabilities.group.availability': 'Availability and delivery',
  'agencySettings.customCapabilities.group.boundaries': 'Nudity and explicit boundaries',
  'agencySettings.customCapabilities.group.partners': 'Partner content',
  'agencySettings.customCapabilities.group.production': 'Wardrobe, purchases and props',
  'agencySettings.customCapabilities.group.scenarios': 'Scenario boundaries',
  'agencySettings.customCapabilities.nudity.clothed': 'Clothed / non-nude',
  'agencySettings.customCapabilities.nudity.lingerie': 'Lingerie',
  'agencySettings.customCapabilities.nudity.topless': 'Topless',
  'agencySettings.customCapabilities.nudity.full_nude': 'Full nude',
  'agencySettings.customCapabilities.nudity.explicit_closeup': 'Explicit close-up',
  'agencySettings.customCapabilities.prop.lingerie': 'Lingerie',
  'agencySettings.customCapabilities.prop.stockings': 'Stockings',
  'agencySettings.customCapabilities.prop.high_heels': 'High heels',
  'agencySettings.customCapabilities.prop.costume': 'Costume / cosplay',
  'agencySettings.customCapabilities.prop.mask': 'Mask',
  'agencySettings.customCapabilities.prop.blindfold': 'Blindfold',
  'agencySettings.customCapabilities.prop.restraints': 'Restraints',
  'agencySettings.customCapabilities.prop.vibrator': 'Vibrator',
  'agencySettings.customCapabilities.prop.dildo': 'Dildo',
  'agencySettings.customCapabilities.prop.butt_plug': 'Butt plug',
  'agencySettings.customCapabilities.prop.body_oil': 'Body oil',
  'agencySettings.customCapabilities.prop.candles': 'Candles',
  'agencySettings.customPricing.previewTitle': 'Quote preview',
  'agencySettings.customPricing.previewHint': 'The floor is protected; the bot opens at the upper price and may negotiate down to the floor.',
  'agencySettings.customPricing.previewError': 'Failed to calculate quote',
  'agencySettings.customPricing.contentType': 'Content type',
  'agencySettings.customPricing.photoCount': 'Photo count',
  'agencySettings.customPricing.duration': 'Duration, minutes',
  'agencySettings.customPricing.urgency': 'Delivery window',
  'agencySettings.customPricing.actualExpenses': 'Confirmed item expenses',
  'agencySettings.customPricing.includeName': 'Name personalization',
  'agencySettings.customPricing.externalItems': 'Requires purchased props or outfit',
  'agencySettings.customPricing.calculate': 'Calculate',
  'agencySettings.customPricing.floor': 'Minimum sale price',
  'agencySettings.customPricing.opening': 'Opening price',
  'agencySettings.customPricing.deposit': 'Tip deposit at opening price',
  'agencySettings.customPricing.externalPending': 'Final price remains pending until the actual prop or outfit cost is confirmed.',

  'agencySettings.monetizationRoutes.eyebrow': 'Sales',
  'agencySettings.monetizationRoutes.title': 'Monetization routes',
  'agencySettings.monetizationRoutes.description': 'Optional sales routes are opt-in and remain disabled until explicitly enabled for this configuration.',
  'agencySettings.monetizationRoutes.navDescription': 'Physical items, approved support campaigns and consent-based style adaptation.',
  'agencySettings.monetizationRoutes.save': 'Save monetization routes',
  'agencySettings.monetizationRoutes.value': 'Value',
  'agencySettings.monetizationRoutes.enabled': 'Enabled',
  'agencySettings.monetizationRoutes.disabled': 'Disabled',
  'agencySettings.monetizationRoutes.badge.manualReview': 'Manual review',
  'agencySettings.monetizationRoutes.badge.modelApproved': 'Model-approved',
  'agencySettings.monetizationRoutes.badge.explicitSignal': 'Explicit signal',
  'agencySettings.monetizationRoutes.physical.title': 'Physical item sales',
  'agencySettings.monetizationRoutes.physical.description': 'Every order requires manual availability, platform-policy and shipping review before price or fulfilment is confirmed.',
  'agencySettings.monetizationRoutes.support.title': 'Support and gift requests',
  'agencySettings.monetizationRoutes.support.description': 'The reason must be truthful, current and approved by the model. Never invent an emergency, debt or pressure a fan.',
  'agencySettings.monetizationRoutes.interaction.title': 'Adaptive interaction and power style',
  'agencySettings.monetizationRoutes.interaction.description': 'Non-sexual delivery adapts only at high confidence. Dominant or receptive power dynamics still require an explicit fan request and consent.',

  'agencySettings.reactivation.settingsTitle': 'History reactivation settings',
  'agencySettings.reactivation.queueTitle': 'Reactivation queue',
  'agencySettings.reactivation.queueHint': 'Review candidates discovered from previous conversations.',
  'agencySettings.reactivation.status': 'Status',
  'agencySettings.reactivation.allStatuses': 'All statuses',
  'agencySettings.reactivation.runTick': 'Run discovery',
  'agencySettings.reactivation.dispatchApproved': 'Dispatch approved',
  'agencySettings.reactivation.fan': 'Fan',
  'agencySettings.reactivation.queueStatus': 'Queue status',
  'agencySettings.reactivation.source': 'Source',
  'agencySettings.reactivation.lastMessage': 'Last message',
  'agencySettings.reactivation.decision': 'Decision',
  'agencySettings.reactivation.approve': 'Approve',
  'agencySettings.reactivation.skip': 'Skip',
  'agencySettings.reactivation.empty': 'No queue items.',
  'agencySettings.reactivation.total': 'Total: {count}',
  'agencySettings.reactivation.queued': 'Reactivation action queued',

  'agencySettings.transitions.add': 'Add transition',
  'agencySettings.transitions.empty': 'No transitions configured.',
  'agencySettings.transitions.key': 'Transition key',
  'agencySettings.transitions.keyPlaceholder': 'transition_key',
  'agencySettings.transitions.emptyKey': 'Transition key is required.',
  'agencySettings.transitions.duplicateKey': 'Duplicate transition key: {key}',

  'agencySettings.conditionalPrompts.title': 'Conditional prompts',
  'agencySettings.conditionalPrompts.hint': 'Additional prompt text applied only when a condition matches.',
  'agencySettings.conditionalPrompts.agent.message_generator': 'Message generator',
  'agencySettings.conditionalPrompts.agent.photo_generator': 'Incoming media reply generator',
  'agencySettings.conditionalPrompts.agent.offer_generator': 'Offer generator',
  'agencySettings.conditionalPrompts.agent.proactive_message_generator': 'Proactive message generator',
  'agencySettings.conditionalPrompts.empty': 'No conditional prompt rules.',
  'agencySettings.conditionalPrompts.addRule': 'Add rule',
  'agencySettings.conditionalPrompts.role': 'Role',
  'agencySettings.conditionalPrompts.order': 'Order',
  'agencySettings.conditionalPrompts.enabled': 'Enabled',
  'agencySettings.conditionalPrompts.prompt': 'Prompt',

  'agencySettings.timewasters.title': 'Timewaster handling',

  'agencySettings.setting.proactive_message_generator_conversation_messages_count': 'Proactive context messages',
  'agencySettings.setting.proactive_followup_max_dispatch_per_tick': 'Max dispatch per tick',
  'agencySettings.setting.proactive_skip_test_fans': 'Skip test fans',
  'agencySettings.setting.proactive_cannot_send_retry_minutes': 'Cannot-send retry minutes',
  'agencySettings.setting.proactive_daily_touch_max_hours': 'Daily touch max hours',
  'agencySettings.setting.proactive_recent_continuation_max_days': 'Recent continuation days',
  'agencySettings.setting.proactive_warm_reactivation_max_days': 'Warm reactivation days',
  'agencySettings.setting.proactive_webhook_users_online_enabled': 'Online event trigger',
  'agencySettings.setting.proactive_webhook_users_typing_enabled': 'Typing event trigger',
  'agencySettings.setting.proactive_webhook_posts_liked_enabled': 'Post liked trigger',
  'agencySettings.setting.proactive_webhook_posts_commented_enabled': 'Post commented trigger',
  'agencySettings.setting.proactive_webhook_min_silence_minutes': 'Minimum silence minutes',
  'agencySettings.setting.proactive_webhook_cooldown_minutes': 'Webhook cooldown minutes',
  'agencySettings.setting.proactive_webhook_custom_events': 'Custom webhook events',
  'agencySettings.setting.history_reactivation_enabled': 'History reactivation enabled',
  'agencySettings.setting.history_reactivation_dry_run': 'Dry run',
  'agencySettings.setting.history_reactivation_batch_size': 'Batch size',
  'agencySettings.setting.history_reactivation_scan_max_pages': 'Scan max pages',
  'agencySettings.setting.history_reactivation_include_active_free': 'Include active free',
  'agencySettings.setting.history_reactivation_include_free_with_history': 'Include free with history',
  'agencySettings.setting.history_reactivation_free_auto_approve': 'Free auto approve',
  'agencySettings.setting.history_reactivation_auto_dispatch_enabled': 'Auto dispatch',
  'agencySettings.setting.history_reactivation_auto_dispatch_limit': 'Auto dispatch limit',
  'agencySettings.setting.history_reactivation_messages_limit': 'Messages to import',
  'agencySettings.setting.history_reactivation_min_silence_hours': 'Minimum silence hours',
  'agencySettings.setting.history_reactivation_max_age_days': 'Maximum age days',
  'agencySettings.setting.history_reactivation_dispatch_limit': 'Dispatch limit',
  'agencySettings.setting.history_reactivation_max_attempts': 'Max attempts',
  'agencySettings.setting.history_reactivation_retry_minutes': 'Retry minutes',
  'agencySettings.setting.prompt_language_match_fan': 'Match fan language',
  'agencySettings.setting.prompt_primary_language': 'Primary language',
  'agencySettings.setting.prompt_allowed_languages': 'Allowed languages',
  'agencySettings.setting.prompt_tone_style': 'Tone style',
  'agencySettings.setting.prompt_emoji_level': 'Emoji level',
  'agencySettings.setting.prompt_message_length': 'Message length',
  'agencySettings.setting.prompt_disallowed_topics': 'Disallowed topics',
  'agencySettings.setting.prompt_custom_safe_instructions': 'Safety instructions',
  'agencySettings.setting.timewaster_strategy_enabled': 'Enable timewaster handling',
  'agencySettings.setting.timewaster_min_fan_messages': 'Fan-message threshold',
  'agencySettings.setting.timewaster_high_tension_min': 'High tension minimum',
  'agencySettings.setting.timewaster_low_spend_intent_max': 'Low spend intent maximum',
  'agencySettings.setting.timewaster_reply_delay_min_seconds': 'Minimum slowed reply, seconds',
  'agencySettings.setting.timewaster_reply_delay_max_seconds': 'Maximum slowed reply, seconds',
  'agencySettings.setting.custom_requests_enabled': 'Allow custom requests',
  'agencySettings.setting.custom_capabilities_configured': 'Enforce configured capabilities',
  'agencySettings.setting.custom_photo_enabled': 'Allow custom photos',
  'agencySettings.setting.custom_video_enabled': 'Allow custom videos',
  'agencySettings.setting.custom_audio_enabled': 'Allow custom audio / voice',
  'agencySettings.setting.personalized_audio_fantasy_enabled': 'Shared fantasy audio path',
  'agencySettings.setting.personalized_audio_fantasy_min_words': 'Minimum developed fantasy words',
  'agencySettings.setting.personalized_audio_fantasy_soft_offer_after_signals': 'Signals before audio suggestion',
  'agencySettings.setting.custom_name_personalization_enabled': 'Allow name personalization',
  'agencySettings.setting.custom_face_allowed': 'Face may be shown',
  'agencySettings.setting.custom_external_items_allowed': 'May source new props/outfits',
  'agencySettings.setting.custom_outfit_purchase_allowed': 'May purchase a requested outfit',
  'agencySettings.setting.custom_prop_purchase_allowed': 'May purchase a requested prop',
  'agencySettings.setting.custom_max_purchase_budget': 'Maximum purchase budget',
  'agencySettings.setting.custom_max_nudity_level': 'Maximum nudity level',
  'agencySettings.setting.custom_toy_use_allowed': 'Toy use allowed',
  'agencySettings.setting.custom_toy_insertion_allowed': 'Toy insertion allowed',
  'agencySettings.setting.custom_other_object_insertion_allowed': 'Other-object insertion allowed',
  'agencySettings.setting.custom_gg_content_allowed': 'GG partner content',
  'agencySettings.setting.custom_bg_content_allowed': 'BG partner content',
  'agencySettings.setting.custom_max_photo_count': 'Maximum custom photos',
  'agencySettings.setting.custom_max_video_minutes': 'Maximum video minutes',
  'agencySettings.setting.custom_max_audio_minutes': 'Maximum audio minutes',
  'agencySettings.setting.custom_standard_turnaround_days': 'Standard turnaround, days',
  'agencySettings.setting.custom_allowed_scenarios': 'Approved scenario ideas',
  'agencySettings.setting.custom_forbidden_scenarios': 'Forbidden scenarios',
  'agencySettings.setting.custom_available_outfits': 'Available outfits',
  'agencySettings.setting.custom_available_locations': 'Available locations',
  'agencySettings.setting.custom_available_prop_categories': 'Available props',
  'agencySettings.setting.custom_available_props': 'Other available props',
  'agencySettings.setting.custom_pricing_enabled': 'Automatic custom pricing',
  'agencySettings.setting.custom_pricing_currency': 'Currency',
  'agencySettings.setting.custom_pricing_base_fee': 'Base production fee',
  'agencySettings.setting.custom_pricing_minimum_total': 'Minimum order',
  'agencySettings.setting.custom_pricing_video_per_minute': 'Video price per minute',
  'agencySettings.setting.custom_pricing_audio_per_minute': 'Audio price per minute',
  'agencySettings.setting.custom_pricing_photo_each': 'Price per photo',
  'agencySettings.setting.custom_pricing_name_markup_percent': 'Name personalization markup, %',
  'agencySettings.setting.custom_pricing_urgency_72h_percent': '72-hour urgency markup, %',
  'agencySettings.setting.custom_pricing_urgency_24h_percent': '24-hour urgency markup, %',
  'agencySettings.setting.custom_pricing_negotiation_margin_percent': 'Negotiation margin, %',
  'agencySettings.setting.custom_pricing_minimum_deposit_percent': 'Minimum tip deposit, %',
  'agencySettings.setting.physical_item_sales_enabled': 'Physical item sales',
  'agencySettings.setting.physical_item_currency': 'Physical item currency',
  'agencySettings.setting.physical_item_underwear_starting_price': 'Underwear starting price',
  'agencySettings.setting.physical_item_clothing_starting_price': 'Clothing starting price',
  'agencySettings.setting.physical_item_other_starting_price': 'Other item starting price',
  'agencySettings.setting.physical_item_worn_day_markup': 'Worn-day markup',
  'agencySettings.setting.physical_item_personalization_markup': 'Personalization markup',
  'agencySettings.setting.support_route_enabled': 'Support and gifts route',
  'agencySettings.setting.support_afterglow_enabled': 'Afterglow tip cue',
  'agencySettings.setting.support_afterglow_min_score': 'Minimum afterglow confidence',
  'agencySettings.setting.support_afterglow_cooldown_days': 'Afterglow cue cooldown, days',
  'agencySettings.setting.support_chat_gate_enabled': 'Free role-play message limit',
  'agencySettings.setting.support_chat_gate_message_limit': 'Messages before soft gate',
  'agencySettings.setting.support_chat_gate_min_tip_amount': 'Minimum tip to continue',
  'agencySettings.setting.support_chat_gate_currency': 'Chat gate currency',
  'agencySettings.setting.support_chat_gate_cooldown_days': 'Chat gate cooldown, days',
  'agencySettings.setting.support_wishlist_enabled': 'Verified wishlist',
  'agencySettings.setting.support_wishlist_url': 'Wishlist URL',
  'agencySettings.setting.support_wishlist_profile_linked': 'Linked in creator profile/bio',
  'agencySettings.setting.support_campaign_enabled': 'Active support campaign',
  'agencySettings.setting.support_campaign_reason': 'Campaign reason',
  'agencySettings.setting.support_campaign_goal_amount': 'Campaign goal amount',
  'agencySettings.setting.support_campaign_currency': 'Campaign currency',
  'agencySettings.setting.support_campaign_cooldown_days': 'Per-fan cooldown, days',
  'agencySettings.setting.adaptive_dominant_style_enabled': 'Adaptive dominant style',
  'agencySettings.setting.adaptive_dominant_style_min_score': 'Minimum explicit-signal score',
  'agencySettings.setting.adaptive_receptive_style_enabled': 'Allow model-receptive power style',
  'agencySettings.setting.adaptive_power_style_max_intensity': 'Maximum power-style intensity',
  'agencySettings.setting.adaptive_interaction_style_enabled': 'Adaptive communication style',
  'agencySettings.setting.adaptive_interaction_style_min_confidence': 'Minimum communication-style confidence',

  'agencySettings.settingDesc.proactive_message_generator_conversation_messages_count': 'How many recent messages are sent into proactive generation context.',
  'agencySettings.settingDesc.proactive_followup_max_dispatch_per_tick': 'Maximum proactive messages sent in one scheduler pass.',
  'agencySettings.settingDesc.proactive_skip_test_fans': 'Prevents proactive jobs from sending to test chats.',
  'agencySettings.settingDesc.proactive_cannot_send_retry_minutes': 'Wait time before retrying after a provider cannot-send result.',
  'agencySettings.settingDesc.proactive_daily_touch_max_hours': 'Upper window for daily touch cadence.',
  'agencySettings.settingDesc.proactive_recent_continuation_max_days': 'How long a recent chat remains eligible for continuation.',
  'agencySettings.settingDesc.proactive_warm_reactivation_max_days': 'How long warm fans stay eligible for reactivation.',
  'agencySettings.settingDesc.proactive_webhook_users_online_enabled': 'React to users-online provider events.',
  'agencySettings.settingDesc.proactive_webhook_users_typing_enabled': 'React to users-typing provider events.',
  'agencySettings.settingDesc.proactive_webhook_posts_liked_enabled': 'React when fans like posts.',
  'agencySettings.settingDesc.proactive_webhook_posts_commented_enabled': 'React when fans comment on posts.',
  'agencySettings.settingDesc.proactive_webhook_min_silence_minutes': 'Minimum silence before event-based proactive messages.',
  'agencySettings.settingDesc.proactive_webhook_cooldown_minutes': 'Cooldown after a webhook-driven message.',
  'agencySettings.settingDesc.proactive_webhook_custom_events': 'Comma-separated extra provider events.',
  'agencySettings.settingDesc.history_reactivation_enabled': 'Allows old conversations to enter reactivation workflows.',
  'agencySettings.settingDesc.history_reactivation_dry_run': 'Discovers candidates without dispatching messages.',
  'agencySettings.settingDesc.history_reactivation_batch_size': 'How many conversations are scanned per batch.',
  'agencySettings.settingDesc.history_reactivation_scan_max_pages': 'Maximum provider pages scanned per run.',
  'agencySettings.settingDesc.history_reactivation_include_active_free': 'Includes active free fans in discovery.',
  'agencySettings.settingDesc.history_reactivation_include_free_with_history': 'Includes free fans with previous chat history.',
  'agencySettings.settingDesc.history_reactivation_free_auto_approve': 'Auto-approves free fan candidates.',
  'agencySettings.settingDesc.history_reactivation_auto_dispatch_enabled': 'Allows approved candidates to be messaged automatically.',
  'agencySettings.settingDesc.history_reactivation_auto_dispatch_limit': 'Maximum auto-dispatched messages per run.',
  'agencySettings.settingDesc.history_reactivation_messages_limit': 'How many old messages are imported for context.',
  'agencySettings.settingDesc.history_reactivation_min_silence_hours': 'Minimum silence before a fan is eligible.',
  'agencySettings.settingDesc.history_reactivation_max_age_days': 'Oldest conversations eligible for reactivation.',
  'agencySettings.settingDesc.history_reactivation_dispatch_limit': 'Manual dispatch cap per run.',
  'agencySettings.settingDesc.history_reactivation_max_attempts': 'Retry attempts for failed candidates.',
  'agencySettings.settingDesc.history_reactivation_retry_minutes': 'Delay between reactivation retries.',
  'agencySettings.settingDesc.prompt_language_match_fan': 'When enabled, replies keep the language used by the fan.',
  'agencySettings.settingDesc.prompt_primary_language': 'Fallback language when the fan language is unknown.',
  'agencySettings.settingDesc.prompt_allowed_languages': 'Comma-separated list of languages the bot may use.',
  'agencySettings.settingDesc.prompt_tone_style': 'Default communication style used by message generation.',
  'agencySettings.settingDesc.prompt_emoji_level': 'Controls how often the bot uses expressive markers.',
  'agencySettings.settingDesc.prompt_message_length': 'Default answer length preference.',
  'agencySettings.settingDesc.prompt_disallowed_topics': 'Comma-separated topics the bot should avoid.',
  'agencySettings.settingDesc.prompt_custom_safe_instructions': 'Agency-level guardrails appended to safe prompts.',
  'agencySettings.settingDesc.timewaster_strategy_enabled': 'Opt-in strategy for fan-initiated long chats with no confirmed payment, high tension and low spend intent.',
  'agencySettings.settingDesc.timewaster_min_fan_messages': 'Minimum incoming fan messages before the strategy can activate.',
  'agencySettings.settingDesc.timewaster_high_tension_min': 'Minimum sexual tension score required for the playful value boundary.',
  'agencySettings.settingDesc.timewaster_low_spend_intent_max': 'Highest spend intent score still treated as low purchase intent.',
  'agencySettings.settingDesc.timewaster_reply_delay_min_seconds': 'Lower bound of the random reply delay while the strategy is active.',
  'agencySettings.settingDesc.timewaster_reply_delay_max_seconds': 'Upper bound of the random reply delay while the strategy is active.',
  'agencySettings.settingDesc.custom_requests_enabled': 'Enables the made-to-order photo, video and audio request route for this model config.',
  'agencySettings.settingDesc.custom_capabilities_configured': 'Makes the formats, limits and boundaries below authoritative for routing and quotes. Complete the matrix first.',
  'agencySettings.settingDesc.custom_photo_enabled': 'The model can currently produce made-to-order photo sets.',
  'agencySettings.settingDesc.custom_video_enabled': 'The model can currently produce made-to-order videos.',
  'agencySettings.settingDesc.custom_audio_enabled': 'The model can currently record made-to-order audio or voice notes.',
  'agencySettings.settingDesc.personalized_audio_fantasy_enabled': 'Allows a shared fan fantasy to develop naturally before one soft suggestion to turn it into a personalized spoken story.',
  'agencySettings.settingDesc.personalized_audio_fantasy_min_words': 'Minimum words required when context, rather than an explicit fantasy phrase, establishes a developed fantasy.',
  'agencySettings.settingDesc.personalized_audio_fantasy_soft_offer_after_signals': 'How many fan fantasy contributions are needed before the bot may suggest personalized audio once.',
  'agencySettings.settingDesc.custom_name_personalization_enabled': 'Allows the fan name to be spoken, written or otherwise included.',
  'agencySettings.settingDesc.custom_face_allowed': 'Allows the model face to appear in made-to-order content.',
  'agencySettings.settingDesc.custom_external_items_allowed': 'Allows orders that require a new item, outfit or prop to be purchased or sourced.',
  'agencySettings.settingDesc.custom_outfit_purchase_allowed': 'Allows an outfit to be bought specifically for the custom and billed at confirmed cost.',
  'agencySettings.settingDesc.custom_prop_purchase_allowed': 'Allows a missing prop to be sourced specifically for the custom.',
  'agencySettings.settingDesc.custom_max_purchase_budget': 'Hard cap for confirmed purchase expenses; zero means manual review with no preset cap.',
  'agencySettings.settingDesc.custom_max_nudity_level': 'Highest visual explicitness approved for this model custom.',
  'agencySettings.settingDesc.custom_toy_use_allowed': 'Allows adult toys to appear or be used.',
  'agencySettings.settingDesc.custom_toy_insertion_allowed': 'Separately allows insertion with an adult toy and requires toy use to be enabled.',
  'agencySettings.settingDesc.custom_other_object_insertion_allowed': 'Allows insertion with an approved non-toy object.',
  'agencySettings.settingDesc.custom_gg_content_allowed': 'Allows made-to-order girl-girl content with another performer.',
  'agencySettings.settingDesc.custom_bg_content_allowed': 'Allows made-to-order boy-girl content with another performer.',
  'agencySettings.settingDesc.custom_max_photo_count': 'Hard photo-count limit enforced before a quote.',
  'agencySettings.settingDesc.custom_max_video_minutes': 'Hard duration limit for one made-to-order video.',
  'agencySettings.settingDesc.custom_max_audio_minutes': 'Hard duration limit for one made-to-order audio.',
  'agencySettings.settingDesc.custom_standard_turnaround_days': 'Normal production window; the bot must not present it as a guaranteed deadline.',
  'agencySettings.settingDesc.custom_allowed_scenarios': 'Comma-separated model-approved themes. Empty does not create an invented whitelist.',
  'agencySettings.settingDesc.custom_forbidden_scenarios': 'Comma-separated hard boundaries; matching requests are blocked before pricing.',
  'agencySettings.settingDesc.custom_available_outfits': 'Only outfits currently available to the model and safe to mention.',
  'agencySettings.settingDesc.custom_available_locations': 'Only safe currently available locations, never private addresses.',
  'agencySettings.settingDesc.custom_available_prop_categories': 'Standard props already available without a new purchase.',
  'agencySettings.settingDesc.custom_available_props': 'Additional available props not covered by the checklist.',
  'agencySettings.settingDesc.custom_pricing_enabled': 'Allows the bot to calculate and negotiate custom orders from these rules.',
  'agencySettings.settingDesc.custom_pricing_currency': 'Currency used for custom quotes and verified tip deposits.',
  'agencySettings.settingDesc.custom_pricing_base_fee': 'Fixed amount added before format-specific rates.',
  'agencySettings.settingDesc.custom_pricing_minimum_total': 'Absolute minimum price the bot cannot cross during negotiation.',
  'agencySettings.settingDesc.custom_pricing_video_per_minute': 'Base rate multiplied by requested video length.',
  'agencySettings.settingDesc.custom_pricing_audio_per_minute': 'Base rate multiplied by requested voice/audio length.',
  'agencySettings.settingDesc.custom_pricing_photo_each': 'Base rate multiplied by requested photo count.',
  'agencySettings.settingDesc.custom_pricing_name_markup_percent': 'Percentage added when the fan name is spoken, written, or personalized.',
  'agencySettings.settingDesc.custom_pricing_urgency_72h_percent': 'Percentage added for delivery within 72 hours.',
  'agencySettings.settingDesc.custom_pricing_urgency_24h_percent': 'Percentage added for delivery within 24 hours; cannot be lower than the 72-hour markup.',
  'agencySettings.settingDesc.custom_pricing_negotiation_margin_percent': 'Markup above the protected floor used as the opening price for bargaining.',
  'agencySettings.settingDesc.custom_pricing_minimum_deposit_percent': 'Share of the agreed total that must arrive as a verified platform tip before production; minimum 50%.',
  'agencySettings.settingDesc.physical_item_sales_enabled': 'Opt in to discussing physical items; availability and shipping always remain pending manual operator review.',
  'agencySettings.settingDesc.physical_item_currency': 'Currency used for starting prices and markups for physical items.',
  'agencySettings.settingDesc.physical_item_underwear_starting_price': 'Starting quote for underwear before wear duration, personalization and shipping are reviewed.',
  'agencySettings.settingDesc.physical_item_clothing_starting_price': 'Starting quote for clothing before personalization and shipping are reviewed.',
  'agencySettings.settingDesc.physical_item_other_starting_price': 'Starting quote for other approved physical items before manual review.',
  'agencySettings.settingDesc.physical_item_worn_day_markup': 'Amount added for each requested day of wear; the model and operator must confirm availability.',
  'agencySettings.settingDesc.physical_item_personalization_markup': 'Amount added for a requested note, name or other approved personalization.',
  'agencySettings.settingDesc.support_route_enabled': 'Allows the configured support/gift route; it never permits fabricated need or unapproved payment instructions.',
  'agencySettings.settingDesc.support_afterglow_enabled': 'Allows one optional native tip cue after the analyzer confirms that a sustained consensual scene has ended positively. It does not trigger during the scene.',
  'agencySettings.settingDesc.support_afterglow_min_score': 'Required analyzer confidence from 50 to 100 before the afterglow support route may run.',
  'agencySettings.settingDesc.support_afterglow_cooldown_days': 'Minimum per-fan wait before another afterglow tip cue can be used.',
  'agencySettings.settingDesc.support_chat_gate_enabled': 'Pauses an active explicit scene after the configured free-message limit and makes one playful native coffee-tip request. Ordinary conversation remains available.',
  'agencySettings.settingDesc.support_chat_gate_message_limit': 'Number of fan turns since the last commercial offer before an active explicit scene may reach the soft gate.',
  'agencySettings.settingDesc.support_chat_gate_min_tip_amount': 'A single verified native tip must meet this amount to resume explicit role-play. Smaller tips are appreciated but do not unlock it.',
  'agencySettings.settingDesc.support_chat_gate_currency': 'Currency used for the minimum verified tip.',
  'agencySettings.settingDesc.support_chat_gate_cooldown_days': 'Minimum per-fan wait before another free-role-play limit request can be made.',
  'agencySettings.settingDesc.support_wishlist_enabled': 'Allows the bot to mention the exact creator-approved wishlist below. It remains a voluntary gift route, never payment for content or access.',
  'agencySettings.settingDesc.support_wishlist_url': 'Exact public HTTPS wishlist URL approved by the creator. The bot must never guess or substitute another link.',
  'agencySettings.settingDesc.support_wishlist_profile_linked': 'Confirms the wishlist is already linked from the creator profile/bio, which is required before the Fansly route may point fans to it.',
  'agencySettings.settingDesc.support_campaign_enabled': 'Activates the current model-approved campaign only when a truthful reason has been entered.',
  'agencySettings.settingDesc.support_campaign_reason': 'Truthful, current reason approved by the model, for example “a black lingerie set already on my wishlist”. The bot may name only details written here. Leave empty when there is no active campaign.',
  'agencySettings.settingDesc.support_campaign_goal_amount': 'Optional transparent target for the approved campaign; zero means no stated target.',
  'agencySettings.settingDesc.support_campaign_currency': 'Currency used for the campaign goal.',
  'agencySettings.settingDesc.support_campaign_cooldown_days': 'Minimum wait before the same fan can receive another campaign request.',
  'agencySettings.settingDesc.adaptive_dominant_style_enabled': 'Allows a dominant tone only after an explicit fan preference or request, never from a weak inference.',
  'agencySettings.settingDesc.adaptive_dominant_style_min_score': 'Required explicit-signal score from 50 to 100; revocation always stops the style regardless of score.',
  'agencySettings.settingDesc.adaptive_receptive_style_enabled': 'Allows the model to become playfully receptive only after the fan explicitly asks to lead. Model boundaries and review rules remain unchanged.',
  'agencySettings.settingDesc.adaptive_power_style_max_intensity': 'Caps consensual dominant or receptive delivery from 1 (subtle) to 5 (strong). It never changes consent, safety, or payment rules.',
  'agencySettings.settingDesc.adaptive_interaction_style_enabled': 'Adapts directness, warmth, playfulness, detail and pace from high-confidence conversational evidence. It never infers sexual consent.',
  'agencySettings.settingDesc.adaptive_interaction_style_min_confidence': 'Minimum analyzer confidence from 50 to 100 before communication traits are stored for the fan.',
}
